export const translations = {
    LAUNCH_CS2: {
        en: "Open Game",
        es: "Abrir Juego",
        pt: "Abrir Jogo"
    },
    LAUNCH_CS2_SUBTITLE: {
        en: "with launch options",
        es: "con opciones de lanzamiento",
        pt: "com opções de lançamento"
    },
    OPENING_CS2: {
        en: "Opening CS2...",
        es: "Abriendo CS2...",
        pt: "Abrindo CS2..."
    },
    STATUS_SAVING: {
        en: "Saving changes...",
        es: "Guardando cambios...",
        pt: "Salvando alterações..."
    },
    STATUS_SAVED: {
        en: "All changes saved",
        es: "Cambios guardados",
        pt: "Alterações salvas"
    },
    STATUS_SYNCING: {
        en: "Syncing with CS2...",
        es: "Sincronizando con CS2...",
        pt: "Sincronizando com CS2..."
    },
    STATUS_SYNCED: {
        en: "Synced with game",
        es: "Sincronizado con el juego",
        pt: "Sincronizado con o jogo"
    },
    // Config Launcher
    SELECT_OR_CREATE: {
        en: "Select or Create a Config",
        es: "Selecciona o Crea una Configuración",
        pt: "Selecione ou Crie uma Configuração"
    },
    DEMO_BANNER_TEXT: {
        en: "This is a demo and changes cannot be saved",
        es: "Esto es una demo y no se pueden guardar los cambios",
        pt: "Esta é uma demo e as alterações não podem ser salvas"
    },
    DEMO_LABEL: {
        en: "DEMO",
        es: "DEMO",
        pt: "DEMO"
    },
    COMING_SOON: {
        en: "COMING SOON",
        es: "PRÓXIMAMENTE",
        pt: "EM BREVE"
    },
    COMING_SOON_LABEL: {
        en: "PRO",
        es: "PRO",
        pt: "PRO"
    },
    PRO_ADD_TO_CONFIG: {
        en: "Add to config",
        es: "Agregar a la config",
        pt: "Adicionar à config"
    },
    PRO_ACTIVATE_DONATION: {
        en: "Unlock with donation",
        es: "Activar con donación",
        pt: "Ativar com doação"
    },
    MULTI_CROSSHAIR_SYSTEM: {
        en: "Multi-Crosshair System",
        es: "Sistema Multi-Mira",
        pt: "Sistema Multi-Mira"
    },
    SIMULATE_RESOLUTION: {
        en: "Simulate Resolution",
        es: "Simular Resolución",
        pt: "Simular Resolução"
    },
    SAVE_PRESET_DESC: {
        en: "Save multiple crosshairs and toggle between them in-game!",
        es: "¡Guarda varias miras y alterna entre ellas dentro del juego!",
        pt: "¡Salve várias miras y alterne entre elas dentro do jogo!"
    },
    MULTI_CROSSHAIR_DESC: {
        en: "Save up to 12 different crosshairs and switch between them in-game by pressing the key assigned in \"TOGGLE BIND\".",
        es: "Guarda hasta 12 miras diferentes y alterna entre ellas dentro del juego presionando la tecla asignada en \"TOGGLE BIND\".",
        pt: "Salve até 12 miras diferentes e alterne entre elas no jogo pressionando a tecla atribuída em \"TOGGLE BIND\"."
    },
    SAVE_CURRENT: {
        en: "SAVE CURRENT",
        es: "GUARDAR ACTUAL",
        pt: "SALVAR ATUAL"
    },
    SAVE_CURRENT_DESC: {
        en: "Save current crosshair as preset",
        es: "Guardar mira actual como preset",
        pt: "Salvar mira atual como preset"
    },
    SAVE_BTN: {
        en: "SAVE",
        es: "GUARDAR",
        pt: "SALVAR"
    },
    TOGGLE_BIND: {
        en: "TOGGLE BIND",
        es: "TOGGLE BIND",
        pt: "TOGGLE BIND"
    },
    TOGGLE_BIND_DESC: {
        en: "Key to switch between crosshairs",
        es: "Tecla para cambiar entre miras",
        pt: "Tecla para alternar entre miras"
    },
    NO_SAVED_CROSSHAIRS: {
        en: "You don't have any saved crosshairs. Create one and save it to get started.",
        es: "No tienes miras guardadas. Crea una y guárdala para empezar.",
        pt: "Você não tem miras salvas. Crie uma e salve-a para começar."
    },
    CROSSHAIR_CODE_LABEL: {
        en: "Crosshair Code",
        es: "Código de Mira",
        pt: "Código de Mira"
    },
    PASTE_SHARECODE_DESC: {
        en: "Paste a \"CSGO-xxxxx-xxxxx\" code",
        es: "Pega un código \"CSGO-xxxxx-xxxxx\"",
        pt: "Cole um código \"CSGO-xxxxx-xxxxx\""
    },
    CFG_CONSOLE_LABEL: {
        en: "CFG File / Console",
        es: "Archivo CFG / Consola",
        pt: "Arquivo CFG / Console"
    },
    PASTE_CROSSHAIR_DESC: {
        en: "Paste your cl_crosshair... commands",
        es: "Pega tus comandos cl_crosshair...",
        pt: "Cole seus comandos cl_crosshair..."
    },
    LOAD_COMMANDS: {
        en: "Load commands",
        es: "Cargar comandos",
        pt: "Carregar comandos"
    },
    COPY_COMMANDS: {
        en: "Copy Commands",
        es: "Copiar Comandos",
        pt: "Copiar Comandos"
    },
    COPY_COMMANDS_DESC: {
        en: "Copy all commands to paste directly in the console.",
        es: "Copia todos los comandos para pegarlos directamente en la consola.",
        pt: "Copie todos os comandos para colar diretamente no console."
    },
    COPY_TO_CLIPBOARD: {
        en: "Copy to clipboard",
        es: "Copiar al portapapeles",
        pt: "Copiar para área de transferência"
    },
    CFG_PREVIEW: {
        en: "CFG Preview",
        es: "Vista previa CFG",
        pt: "Prévia do CFG"
    },
    READY_TO_PASTE: {
        en: "READY TO PASTE",
        es: "LISTO PARA PEGAR",
        pt: "PRONTO PARA COLAR"
    },
    GENERATE_RANDOM: {
        en: "Generate Random",
        es: "Generar Random",
        pt: "Gerar Aleatório"
    },
    GENERATE_RANDOM_DESC: {
        en: "Generate new random crosshairs",
        es: "Generar nuevas miras aleatorias",
        pt: "Gerar novas miras aleatórias"
    },
    RECOMMENDED: {
        en: "Recommended",
        es: "Recomendadas",
        pt: "Recomendadas"
    },
    SEARCH_PLACEHOLDER: {
        en: "Search...",
        es: "Buscar...",
        pt: "Buscar..."
    },
    PRESET_ALREADY_EXISTS: {
        en: "This crosshair configuration is already saved in your presets.",
        es: "Esta configuración de mira ya está guardada en tus presets.",
        pt: "Esta configuração de mira ya está salva em seus presets."
    },
    SAVE_TO_SLOTS: {
        en: "ADD SAVED",
        es: "AÑADIR A PRESETS",
        pt: "ADICIONAR A PRESETS"
    },
    UNDER_CONSTRUCTION: {
        en: "UNDER CONSTRUCTION",
        es: "EN CONSTRUCCIÓN",
        pt: "EM CONSTRUÇÃO"
    },
    SPLASH_TITLE: {
        en: "Configure like a Pro and Play like a Legend",
        es: "Configura como un Pro y juega como una Leyenda",
        pt: "Configure como um Pro e jogue como uma Lenda"
    },
    TOOL_DESCRIPTION: {
        en: "In this section you can manage your CS2 configurations. You can start with a new one or duplicate an existing one and change its name to begin customizing it.",
        es: "En esta seccion podras administrar tus configuraciones de CS2. Puedes iniciar con una nueva o duplicar una existente y cambiarle el nombre para comenzar a personalizarla.",
        pt: "Nesta seccion podras administrar suas configurações de CS2. Você pode começar com uma nova ou duplicar uma existente e mudar o nome para começar a personalizá-la."
    },
    LOG_IN_PROMPT: {
        en: "Log in",
        es: "Inicia sesión",
        pt: "Fazer login"
    },
    CREATE_NEW: {
        en: "Create New",
        es: "Crear Nueva",
        pt: "Criar Nova"
    },
    DUPLICATE_CONFIG_TITLE: {
        en: "Duplicate Config",
        es: "Duplicar Config",
        pt: "Duplicar Config"
    },
    RENAME_ACTION: {
        en: "Rename",
        es: "Renombrar",
        pt: "Renomear"
    },
    EDIT_ACTION: {
        en: "Edit",
        es: "Editar",
        pt: "Editar"
    },
    DUPLICATE_ACTION: {
        en: "Duplicate",
        es: "Duplicar",
        pt: "Duplicar"
    },
    CREATE_ACTION: {
        en: "Create",
        es: "Crear",
        pt: "Criar"
    },
    DUPLICATE_DEFAULT_NAME: {
        en: "New Config",
        es: "Nueva Config",
        pt: "Nova Config"
    },
    MY_LIBRARY: {
        en: "My Library",
        es: "Mi Biblioteca",
        pt: "Minha Biblioteca"
    },
    LOADING: {
        en: "Loading...",
        es: "Cargando...",
        pt: "Carregando..."
    },
    NO_CONFIGS_SAVED: {
        en: "No configs saved. Create a new one to get started.",
        es: "No hay configuraciones guardadas. Crea una nueva para comenzar.",
        pt: "Não há configurações salvas. Crie uma nueva para comenzar."
    },
    DELETE_CONFIRM: {
        en: "Are you sure you want to delete this config?",
        es: "¿Estás seguro de que quieres eliminar esta configuración?",
        pt: "¿Estás seguro de que quieres eliminar esta configuração?"
    },
    DELETE_PRESET_CONFIRM: {
        en: "Are you sure you want to delete this saved crosshair?",
        es: "¿Estás seguro de que quieres eliminar esta mira guardada?",
        pt: "Tem certeza que deseja excluir esta mira salva?"
    },
    DELETE_PRESET_TITLE: {
        en: "Delete Crosshair",
        es: "Eliminar Mira",
        pt: "Excluir Mira"
    },
    DELETE_CONFIG: {
        en: "Delete Config",
        es: "Eliminar Configuración",
        pt: "Eliminar Configuração"
    },
    DELETE_ACTION: {
        en: "Delete",
        es: "Eliminar",
        pt: "Excluir"
    },
    LOCK_ACTION: {
        en: "Lock",
        es: "Bloquear",
        pt: "Bloquear"
    },
    UNLOCK_ACTION: {
        en: "Unlock",
        es: "Desbloquear",
        pt: "Desbloquear"
    },
    AUTOLOAD_ENABLED: {
        en: "AutoLoad Enabled",
        es: "Carga Automática Activada",
        pt: "Carregamento Automático Ativado"
    },
    DISABLE_AUTOLOAD: {
        en: "Disable AutoLoad",
        es: "Desactivar Carga Automática",
        pt: "Desativar Carregamento Automático"
    },
    SET_AUTOLOAD: {
        en: "Select",
        es: "Seleccionar",
        pt: "Selecionar"
    },
    SELECTED_CONFIG: {
        en: "Selected Config",
        es: "Config seleccionada",
        pt: "Config selecionada"
    },
    SELECTED: {
        en: "SELECTED",
        es: "SELECCIONADA",
        pt: "SELECIONADA"
    },
    AUTOLOAD_MSG: {
        en: "Loads automatically when opening the game",
        es: "Se carga automáticamente al abrir el juego",
        pt: "Carrega automaticamente ao abrir o jogo"
    },
    SYSTEM_STATUS: {
        en: "Modules Status",
        es: "Estado de los Módulos",
        pt: "Estado dos Módulos"
    },
    ACTIVE_CONFIG: {
        en: "Active Configuration",
        es: "Configuración Activa",
        pt: "Configuração Activa"
    },
    ACTIVE_MODULES_COUNT: {
        en: "Active Modules",
        es: "Módulos Activos",
        pt: "Módulos Ativos"
    },
    ACTIVE_MODULES_TOOLTIP: {
        en: "Modules can be activated in each section",
        es: "Los módulos se pueden activar en cada sección",
        pt: "Os módulos podem ser ativados em cada seção"
    },
    MODULE_ACTIVE: {
        en: "In config",
        es: "En la config",
        pt: "Na config"
    },
    ACTIVATE_MODULE: {
        en: "Add to config",
        es: "Agregar a la config",
        pt: "Adicionar à config"
    },
    RESTORE_BACKUP: {
        en: "Restore Backup",
        es: "Restaurar Backup",
        pt: "Restaurar Backup"
    },
    RESTORE_TOOLTIP: {
        en: "We have made a copy of your initial configuration in case you wanted to go back",
        es: "Hemos hecho una copia de tu configuracion inicial por si querias volver atras",
        pt: "Fizemos uma cópia da sua configuração inicial caso você queira voltar atrás"
    },
    TAB_CFG_EDITOR: {
        en: "CFG Editor",
        es: "Editor de CFG",
        pt: "Editor de CFG"
    },
    TAB_VIDEO_PARAMETERS: {
        en: "Video Parameters",
        es: "Parámetros de Video",
        pt: "Parâmetros de Vídeo"
    },
    TAB_ADVANCED: {
        en: "Advanced",
        es: "Avanzado",
        pt: "Avançado"
    },
    TAB_LAUNCH_OPTIONS: {
        en: "Launch Options",
        es: "Lanzamiento",
        pt: "Inicialização"
    },
    HOME_WELCOME_PREFIX: {
        en: "Welcome to the ultimate",
        es: "Bienvenido al definitivo",
        pt: "Bem-vindo ao definitivo"
    },
    HOME_WELCOME_HUB: {
        en: "CS2 Configuration Hub",
        es: "Hub de Configuración CS2",
        pt: "Hub de Configuração CS2"
    },
    HOME_DESC_P1: {
        en: "Customize your crosshair, viewmodel, binds, and more with our visual editor.",
        es: "Personaliza tu mira, modelo de vista, atajos y más con nuestro editor visual."
    },
    HOME_DESC_P2: {
        en: "Apply changes directly to your game files and dominate the game.",
        es: "Aplica cambios directamente en tu juego y domina el juego."
    },
    HOME_DESCRIPTION_AUTO: {
        en: "We automatically detect your Counter-Strike folder and take care of saving the configuration files there. Don't worry about your previous setup, we've made a backup so you can restore it whenever you want.",
        es: "Buscamos automáticamente tu carpeta de Counter-Strike para guardar tus archivos de configuración ahí. No te preocupes por tu configuración anterior, hemos hecho un backup para que la restaures siempre que quieras.",
        pt: "Buscamos automaticamente sua pasta de Counter-Strike para salvar seus arquivos de configuração ahí. Não se preocupe com tu configuração anterior, fizemos um backup para que você restaure quando quiser."
    },
    CFG_FOLDER_FOUND_SHORT: {
        en: "LOCATION DETECTED",
        es: "UBICACIÓN DETECTADA",
        pt: "LOCALIZAÇÃO DETECTADA"
    },
    DETECT_CS2_FOLDER: {
        en: "DETECT CS2 LOCATION",
        es: "DETECTAR UBICACIÓN CS2"
    },
    WEB_MODE_DEMO: {
        en: "WEB MODE (DEMO)",
        es: "MODO WEB (DEMO)",
        pt: "MODO WEB (DEMO)"
    },
    DEMO_DOWNLOAD_BLOCKED: {
        en: "Download is not available in Demo Mode. Please log in for full access.",
        es: "La descarga no está disponible en Modo Demo. Por favor inicia sesión para acceso completo.",
        pt: "O download não está disponível no Modo Demo. Por favor, faça login para acesso completo."
    },
    MODULE_STATUS_TITLE: {
        en: "MODULE STATUS",
        es: "ESTADO DE MÓDULOS",
        pt: "ESTADO DOS MÓDULOS"
    },
    DASHBOARD_WELCOME: {
        en: "Here you can see a preview of your configuration and go to each module by clicking on them. Remember to activate or deactivate modules without losing their configuration.",
        es: "Aquí podrás ver una preview de tu configuración e ir a cada módulo haciendo clic en ellos. Recuerda activar o desactivar los módulos sin perder su configuración",
        pt: "Aqui você poderá ver uma prévia da sua configuração e ir para cada módulo clicando neles. Lembre-se de ativar ou desativar os módulos sem perder sua configuração"
    },
    CREATE_CONFIG: {
        en: "Create Config",
        es: "Crear Configuración",
        pt: "Crear Configuração"
    },
    NEW_CONFIG_DEFAULT_NAME: {
        en: "New Config",
        es: "Nueva Configuración",
        pt: "Nova Configuração"
    },
    TEMPLATE_DEFAULT: {
        en: "Default (CS2 Standard)",
        es: "Por defecto (Estándar CS2)",
        pt: "Padrão (Padrão CS2)"
    },
    TEMPLATE_EMPTY: {
        en: "Empty (No Settings)",
        es: "Limpia (Sin ajustes)",
        pt: "Limpa (Sem ajustes)"
    },
    TEMPLATE_RECOMMENDED: {
        en: "Recommended (Competitive)",
        es: "Recomendada (Competitivo)",
        pt: "Recomendada (Competitivo)"
    },
    MY_CONFIGS: {
        en: "Based on My Configs",
        es: "Basada en mis Configs",
        pt: "Baseada em minhas Configs"
    },
    CS2_FOLDER_NOT_FOUND: {
        en: "CS2 FOLDER NOT FOUND",
        es: "CARPETA CS2 NO ENCONTRADA",
        pt: "PASTA CS2 NÃO ENCONTRADA"
    },
    CS2_FOLDER_NOT_FOUND_DESC: {
        en: "Set the path to install your configs",
        es: "Configura la ruta para instalar tus configs",
        pt: "Configure o caminho para instalar suas configs"
    },
    RECALCULATE_PATH: {
        en: "Recalculate Path",
        es: "Volver a buscar carpeta de CS2",
        pt: "Buscar novamente pasta do CS2"
    },
    SELECT_MANUAL_FOLDER: {
        en: "SELECT FOLDER MANUALLY",
        es: "CAMBIAR CARPETA MANUALMENTE",
        pt: "MUDAR PASTA MANUALMENTE"
    },
    AUTO_DETECT_PATH: {
        en: "AUTO DETECT",
        es: "AUTODETECTAR",
        pt: "AUTODETECTAR"
    },
    APPLY_CS2: {
        en: "Apply Changes",
        es: "Aplicar Cambios",
        pt: "Aplicar Alterações"
    },
    SYNC_JUST_NOW: {
        en: "Just now",
        es: "Justo ahora",
        pt: "Agora mesmo"
    },
    SYNC_SECONDS_AGO: {
        en: " seconds ago",
        es: "Hace {seconds} segundos",
        pt: "Há {seconds} segundos"
    },
    SYNC_MINUTES_AGO: {
        en: " minutes ago",
        es: "Hace {minutes} min",
        pt: "Há {minutes} min"
    },
    SYNCING_FILES: {
        en: "SYNCING...",
        es: "SINCRONIZANDO...",
        pt: "SINCRONIZANDO..."
    },
    FILES_UPDATED_IN_GAME: {
        en: "FILES UPDATED",
        es: "ARCHIVOS ACTUALIZADOS",
        pt: "ARQUIVOS ATUALIZADOS"
    },
    SYNCED_IN_GAME: {
        en: "SYNCED",
        es: "SINCRONIZADO",
        pt: "SINCRONIZADO"
    },
    UPDATING_GAME_CFG: {
        en: "Updating game files",
        es: "Actualizando archivos",
        pt: "Atualizando arquivos"
    },
    SYNC_STATUS_TOOLTIP: {
        en: "Game files have been updated successfully.",
        es: "Los archivos del juego han sido actualizados.",
        pt: "Os arquivos do jogo foram atualizados."
    },
    READY_TO_SYNC: {
        en: "Ready to sync",
        es: "Listo para sincronizar",
        pt: "Pronto para sincronizar"
    },
    HOME_STEP_CUSTOMIZE_TITLE: {
        en: "Customize",
        es: "Personaliza",
        pt: "Personalize"
    },
    HOME_STEP_CUSTOMIZE_DESC: {
        en: "Use the visual tools in the sidebar to tweak every aspect of your game configuration.",
        es: "Usa las herramientas visuales de la barra lateral para ajustar cada aspecto de tu configuración.",
        pt: "Use as ferramentas visuais da barra lateral para ajustar cada aspecto de tu configuração."
    },
    HOME_STEP_PREVIEW_TITLE: {
        en: "Preview",
        es: "Previsualiza",
        pt: "Visualize"
    },
    HOME_STEP_PREVIEW_DESC: {
        en: "See your changes in real-time with our accurate in-game simulation previews.",
        es: "Mira tus cambios en tiempo real con nuestras previsualizaciones precisas.",
        pt: "Veja suas alterações em tempo real com nossas visualizações precisas."
    },
    HOME_STEP_EXPORT_TITLE: {
        en: "Export",
        es: "Exportar",
        pt: "Exportar"
    },
    HOME_STEP_EXPORT_DESC: {
        en: "Download your config or copy to clipboard to use it instantly in Counter-Strike 2.",
        es: "Descarga tu config o cópiala al portapapeles para usarla al instante.",
        pt: "Baixe sua config ou copie-a para a área de transferência para usá-la instantaneamente."
    },
    PRESET_EMPTY: {
        en: "New Empty Config",
        es: "Config nueva vacia",
        pt: "Config nova vazia"
    },
    PRESET_DEFAULT: {
        en: "Default",
        es: "Por Defecto",
        pt: "Padrão"
    },
    PRESET_RECOMMENDED: {
        en: "Recommended",
        es: "Recomendada",
        pt: "Recomendada"
    },
    NAME_EXISTS: {
        en: "Config name already exists",
        es: "El nombre de la config ya existe",
        pt: "O nome da config já existe"
    },
    MANAGER: {
        en: "Manager",
        es: "Manager",
        pt: "Gerenciador"
    },
    DOWNLOAD_ALL_ZIP: {
        en: "Download Backup (.ZIP)",
        es: "Descargar Backup (.ZIP)",
        pt: "Baixar Backup (.ZIP)"
    },
    CONFIG_MANAGER_TITLE: {
        en: "Manager",
        es: "Manager",
        pt: "Gerenciador"
    },
    IMPORT_FULL_CONFIG: {
        en: "Import Full Config",
        es: "Importar Config Completa",
        pt: "Importar Config Completa"
    },
    IMPORT_CONFIG: {
        en: "Import Config",
        es: "Importar Config",
        pt: "Importar Config"
    },
    PASTE_CFG_CONTENT: {
        en: "Paste your CFG file content (binds, crosshair, etc):",
        es: "Pega el contenido de tu archivo CFG (binds, miras, etc):",
        pt: "Cole o conteúdo do seu arquivo CFG (binds, miras, etc):"
    },
    RESTORE_CONFIRM: {
        en: "Are you sure you want to restore the original config? This will overwrite current autoexec settings.",
        es: "¿Estás seguro de que deseas restaurar la configuración original? Esto sobrescribirá la configuración actual.",
        pt: "Você tem certeza que deseja restaurar la configuração original? Isso sobrescreverá la configuração atual."
    },
    SELECT_RATIO: {
        en: "SELECT RATIO",
        es: "SELECCIONA RATIO",
        pt: "SELECIONAR RATIO"
    },
    CONFIG_NAME_LABEL: {
        en: "Config Name",
        es: "Nombre de Config",
        pt: "Nome da Config"
    },
    TEMPLATE_LABEL: {
        en: "Template",
        es: "Plantilla",
        pt: "Modelo"
    },
    RENAME_CONFIG: {
        en: "Rename Config",
        es: "Renombrar Configuración",
        pt: "Renomear Configuração"
    },
    TABLE_STATUS: {
        en: "Status",
        es: "Estado",
        pt: "Estado"
    },
    TABLE_BIND: {
        en: "Launcher Bind",
        es: "Atajo de Inicio",
        pt: "Atalho de Início"
    },
    TABLE_UPDATED: {
        en: "Last Updated",
        es: "Última act.",
        pt: "Última act."
    },
    BATCH_DELETE: {
        en: "Delete Selected",
        es: "Eliminar Seleccionados",
        pt: "Excluir Selecionados"
    },
    CONFIRM_BATCH_DELETE: {
        en: "Are you sure you want to delete {count} configs?",
        es: "¿Estás seguro de que quieres eliminar {count} configuraciones?",
        pt: "Tem certeza que deseja excluir {count} configurações?"
    },
    SELECT_BASE: {
        en: "Select a template or config to start from:",
        es: "Selecciona una plantilla o config para iniciar:",
        pt: "Selecione um modelo ou config para começar:"
    },

    // Sidebar
    SELECT_CFG: {
        en: "Select CFG",
        es: "Seleccionar CFG",
        pt: "Selecionar CFG"
    },
    SAVE_TO_CLOUD: {
        en: "Save to Cloud",
        es: "Guardar en Nube",
        pt: "Salvar na Nuvem"
    },
    CREATE_NEW_CONFIG: {
        en: "Create new config",
        es: "Crear nueva config",
        pt: "Criar nova config"
    },
    PREVIEW: {
        en: "PREVIEW",
        es: "VISTA PREVIA",
        pt: "VISUALIZAÇÃO"
    },
    DOWNLOAD_CFG: {
        en: "Download",
        es: "Descargar",
        pt: "Baixar"
    },
    READ_ONLY: {
        en: "Read Only",
        es: "Solo Lectura",
        pt: "Somente Leitura"
    },
    LOCKED_STATUS: {
        en: "Locked",
        es: "Bloqueado",
        pt: "Bloqueado"
    },
    ENABLE_EDITING: {
        en: "Enable Editing",
        es: "Habilitar Edición",
        pt: "Habilitar Edição"
    },
    SET_READ_ONLY: {
        en: "Read Only",
        es: "Solo Lectura",
        pt: "Somente Leitura"
    },
    CONFIG_SAVED_SUCCESS: {
        en: "Configuration Saved Successfully!",
        es: "¡Configuración guardada satisfactoriamente!",
        pt: "¡Configuração guardada satisfactoriamente!"
    },
    LOGIN_WITH_STEAM: {
        en: "Login with Steam",
        es: "Iniciar sesión con Steam",
        pt: "Fazer login com Steam"
    },
    JUMP_THROW: {
        en: "Jump Throw",
        es: "Jump Throw",
        pt: "Jump Throw"
    },
    ERROR_SAVING: {
        en: "Error saving",
        es: "Error al guardar",
        pt: "Erro ao salvar"
    },
    ERROR: {
        en: "Error",
        es: "Error",
        pt: "Erro"
    },
    CONFIG_NAME_EXISTS: {
        en: "Configuration name already exists",
        es: "El nombre de la configuración ya existe",
        pt: "O nome da configuração já existe"
    },
    MY_NEW_CONFIG_PLACEHOLDER: {
        en: "My new configuration",
        es: "Mi nueva configuración",
        pt: "Minha nova configuração"
    },
    BINDS_CUSTOM_TITLE: {
        en: "Custom Binds",
        es: "Binds Personalizados",
        pt: "Binds Personalizados"
    },
    RADIO_COMMUNICATION_TITLE: {
        en: "Radio Communication",
        es: "Comunicación de Radio",
        pt: "Comunicação de Rádio"
    },
    LIMITED_SYSTEM_FEATURES: {
        en: "Limited system features",
        es: "Funciones de sistema limitadas",
        pt: "Recursos do sistema limitados"
    },
    DUPLICATED_SUFFIX: {
        en: "(Copy)",
        es: "(Copia)",
        pt: "(Cópia)"
    },
    YOUR_CONFIGS: {
        en: "Your Configs",
        es: "Tus Configs",
        pt: "Suas Configs"
    },
    YOUR_CFG_APPEAR_HERE: {
        en: "Your CFG files will appear here",
        es: "Aquí aparecerán tus archivos CFG",
        pt: "Aqui aparecerão seus arquivos CFG"
    },
    MEMBER_SAVE_MULTIPLE: {
        en: "Members can save multiple configurations",
        es: "Si eres miembro podrás tener varias configs guardadas",
        pt: "Si eres miembro poderá tener varias configs guardadas"
    },
    HELP: {
        en: "Help",
        es: "Ayuda",
        pt: "Ajuda"
    },
    EXPAND_ALL: {
        en: "Expand all",
        es: "Expandir todos",
        pt: "Expandir todos"
    },
    COLLAPSE_ALL: {
        en: "Collapse all",
        es: "Colapsar todos",
        pt: "Recolher todos"
    },
    TOGGLE_TERMINAL_SHOW: {
        en: "Show Terminal",
        es: "Mostrar Terminal",
        pt: "Mostrar Terminal"
    },
    TOGGLE_TERMINAL_HIDE: {
        en: "Hide Terminal",
        es: "Ocultar Terminal",
        pt: "Ocultar Terminal"
    },
    SIDEBAR_MODULES: {
        en: "Modules",
        es: "Módulos",
        pt: "Módulos"
    },
    SIDEBAR_DASHBOARD: {
        en: "DASHBOARD",
        es: "INICIO",
        pt: "PAINEL"
    },
    // Estas dos faltaban: el sidebar mostraba la CLAVE cruda ("SETTINGS",
    // "LANGUAGE"), que al ser texto en inglés pasaba desapercibida. El
    // fallback `t('SETTINGS') || 'Settings'` nunca se activaba porque t()
    // devuelve la clave, que es truthy.
    // --- Export .cfg (modal del editor, modo web) ---
    EXPORT_CFG: {
        en: "EXPORT CFG",
        es: "EXPORTAR CFG",
        pt: "EXPORTAR CFG"
    },
    EXPORT_CFG_SUBTITLE: {
        en: "download your config",
        es: "descargá tu config",
        pt: "baixe sua config"
    },
    LAUNCH_CS2_WEB_ONLY: {
        en: "Only available in the desktop app — download it to launch CS2 from here.",
        es: "Solo disponible en la app de escritorio — descargala para abrir CS2 desde acá.",
        pt: "Disponível apenas no app para desktop — baixe-o para abrir o CS2 daqui."
    },
    EXPORT_MODAL_TITLE: {
        en: "Export .cfg",
        es: "Exportar .cfg",
        pt: "Exportar .cfg"
    },
    EXPORT_MODAL_INTRO: {
        en: "Pick the sections you want and download the file. Drop it into your CS2 cfg folder and run it from the console with exec.",
        es: "Elegí las secciones que quieras y descargá el archivo. Ponelo en tu carpeta cfg de CS2 y ejecutalo desde la consola con exec.",
        pt: "Escolha as seções que quiser e baixe o arquivo. Coloque-o na sua pasta cfg do CS2 e execute pelo console com exec."
    },
    EXPORT_MODAL_SECTIONS: {
        en: "Sections to export",
        es: "Secciones a exportar",
        pt: "Seções para exportar"
    },
    EXPORT_MODAL_ALL: {
        en: "Select all",
        es: "Seleccionar todo",
        pt: "Selecionar tudo"
    },
    EXPORT_MODAL_NONE: {
        en: "Clear",
        es: "Limpiar",
        pt: "Limpar"
    },
    EXPORT_MODAL_NOTHING: {
        en: "This config has nothing to export yet. Tweak something in the editor first.",
        es: "Esta config todavía no tiene nada para exportar. Tocá algo en el editor primero.",
        pt: "Esta config ainda não tem nada para exportar. Ajuste algo no editor primeiro."
    },
    EXPORT_MODAL_DOWNLOAD: {
        en: "Download .cfg",
        es: "Descargar .cfg",
        pt: "Baixar .cfg"
    },
    EXPORT_MODAL_VIEW: {
        en: "View cfg",
        es: "Ver cfg",
        pt: "Ver cfg"
    },
    EXPORT_MODAL_HIDE: {
        en: "Hide cfg",
        es: "Ocultar cfg",
        pt: "Ocultar cfg"
    },
    EXPORT_MODAL_COPY: {
        en: "Copy",
        es: "Copiar",
        pt: "Copiar"
    },
    EXPORT_MODAL_INDIVIDUAL: {
        en: "Or download them one by one",
        es: "O descargalas una por una",
        pt: "Ou baixe uma por uma"
    },
    EXPORT_MODAL_DOWNLOAD_ONE: {
        en: "Download this section",
        es: "Descargar esta sección",
        pt: "Baixar esta seção"
    },
    EXPORT_SECTION_CROSSHAIR: {
        en: "Crosshair",
        es: "Mira",
        pt: "Mira"
    },
    EXPORT_SECTION_MOUSE: {
        en: "Mouse / Sens",
        es: "Mouse / Sens",
        pt: "Mouse / Sens"
    },
    EXPORT_SECTION_VIEWMODEL: {
        en: "Viewmodel",
        es: "Viewmodel",
        pt: "Viewmodel"
    },
    EXPORT_SECTION_HUD: {
        en: "HUD / Radar",
        es: "HUD / Radar",
        pt: "HUD / Radar"
    },
    EXPORT_SECTION_BINDS_BASIC: {
        en: "Basic binds",
        es: "Binds básicos",
        pt: "Binds básicos"
    },
    EXPORT_SECTION_BINDS_SPECIAL: {
        en: "Special binds",
        es: "Binds especiales",
        pt: "Binds especiais"
    },
    EXPORT_SECTION_BINDS_CUSTOM: {
        en: "Custom binds",
        es: "Binds propios",
        pt: "Binds próprios"
    },
    EXPORT_SECTION_RADIO: {
        en: "Radio",
        es: "Radio",
        pt: "Rádio"
    },
    EXPORT_SECTION_GRAPHICS: {
        en: "Graphics",
        es: "Gráficos",
        pt: "Gráficos"
    },
    EXPORT_SECTION_VIDEO: {
        en: "Video / FPS",
        es: "Video / FPS",
        pt: "Vídeo / FPS"
    },
    EXPORT_SECTION_PRACTICE: {
        en: "Practice",
        es: "Práctica",
        pt: "Treino"
    },
    EXPORT_SECTION_SCRIPTS: {
        en: "Scripts",
        es: "Scripts",
        pt: "Scripts"
    },
    SETTINGS: {
        en: "SETTINGS",
        es: "AJUSTES",
        pt: "AJUSTES"
    },
    LANGUAGE: {
        en: "LANGUAGE",
        es: "IDIOMA",
        pt: "IDIOMA"
    },
    SIDEBAR_HOME: {
        en: "HOME",
        es: "INICIO",
        pt: "INÍCIO"
    },
    SIDEBAR_MANAGER: {
        en: "MANAGER",
        es: "MANAGER",
        pt: "GERENCIADOR"
    },
    SIDEBAR_WIKI: {
        en: "WIKI",
        es: "WIKI",
        pt: "WIKI"
    },
    SIDEBAR_BLOG: {
        en: "ACTIVAR",
        es: "ACTIVAR",
        pt: "ATIVAR"
    },
    SIDEBAR_UPDATES: {
        en: "UPDATES",
        es: "NOTAS DE ACTUALIZACIÓN",
        pt: "NOTAS DE ATUALIZAÇÃO"
    },
    SIDEBAR_EDITOR: {
        en: "EDITOR",
        es: "EDITOR",
        pt: "EDITOR"
    },
    DASHBOARD_TITLE_PREFIX: {
        en: "Dash",
        es: "Ini",
        pt: "Pai"
    },
    DASHBOARD_TITLE_SUFFIX: {
        en: "board",
        es: "cio",
        pt: "nel"
    },
    MANAGER_TITLE_PREFIX: {
        en: "Man",
        es: "Man",
        pt: "Geren"
    },
    MANAGER_TITLE_SUFFIX: {
        en: "ager",
        es: "ager",
        pt: "ciador"
    },
    EDITOR_TITLE_PREFIX: {
        en: "Edi",
        es: "Edi",
        pt: "Edi"
    },
    EDITOR_TITLE_SUFFIX: {
        en: "tor",
        es: "tor",
        pt: "tor"
    },
    SIDEBAR_DEMO_TITLE: {
        en: "DEMO MODE",
        es: "MODO DEMO",
        pt: "MODO DEMO"
    },
    SIDEBAR_DEMO_DESC: {
        en: "In the demo version you can only export crosshair and viewmodel commands.",
        es: "En la versión demo solamente podrás exportar comandos de crosshair y de viewmodel.",
        pt: "Na versão demo você só pode exportar comandos de crosshair e viewmodel."
    },
    START_MAGIC: {
        en: "MAGIC SETUP",
        es: "ASISTENTE MÁGICO",
        pt: "CONFIGURAÇÃO MÁGICA"
    },
    CREATE_NEW_PROFILE: {
        en: "Create New Profile",
        es: "Crear Nuevo Perfil",
        pt: "Criar Novo Perfil"
    },
    CUSTOM_SCRIPTS_TITLE: {
        en: "Custom Scripts",
        es: "Scripts Personalizados",
        pt: "Scripts Personalizados"
    },
    MY_CONFIGS_UPPER: {
        en: "MY CONFIGS",
        es: "MIS CONFIGS",
        pt: "MINHAS CONFIGS"
    },
    // Export Page
    EXPORT_TITLE: {
        en: "Export Config",
        es: "Exportar Configuración",
        pt: "Exportar Configuração"
    },
    EXPORT_SUBTITLE: {
        en: "Download, copy or share your Counter-Strike 2 configuration.",
        es: "Descarga, copia o comparte tu configuración de Counter-Strike 2.",
        pt: "Baixe, copie ou compartilhe sua configuração de Counter-Strike 2."
    },
    SUPPORT_TITLE: {
        en: "Support Us",
        es: "Apóyanos",
        pt: "Apoie-nos"
    },
    SUPPORT_TEXT: {
        en: "If you like this tool and want to support its development, consider making a donation. Your help allows us to keep improving and adding new features!",
        es: "Si te gusta esta herramienta y quieres apoyar su desarrollo, considera hacer una donación. ¡Tu ayuda nos permite seguir mejorando y añadiendo nuevas funcionalidades!",
        pt: "Se você gosta desta ferramenta e quer apoiar seu desenvolvimento, considere fazer uma doação. Sua ajuda nos permite continuar melhorando e adicionando novas funcionalidades!"
    },
    JOIN_PATREON: {
        en: "Join Patreon",
        es: "Unirse a Patreon",
        pt: "Junte-se ao Patreon"
    },
    SUPPORT_SUBSCRIBESTAR: {
        en: "Support on SubscribeStar",
        es: "Apoyar en SubscribeStar",
        pt: "Apoiar no SubscribeStar"
    },
    CANT_SUBSCRIBE_TITLE: {
        en: "Can't subscribe?",
        es: "¿No puedes suscribirte?",
        pt: "¿Não pode se inscrever?"
    },
    CANT_SUBSCRIBE_TEXT: {
        en: "It doesn't matter, we still give you the possibility to export the crosshair and viewmodel modules. But I only ask you to please share our app on your social networks so that more people can enjoy this tool and someone can support us.",
        es: "No importa, igual te damos la posibilidad de exportar los módulos de crosshair y viewmodel. Pero te pido solo el favor de que compartas nuestra app en tus redes sociales para que más personas puedan disfrutar de esta herramienta y alguien pueda apoyarnos.",
        pt: "Não importa, ainda damos a você a possibilidade de exportar os módulos de crosshair e viewmodel. Mas peço apenas o favor de compartilhar nosso app em suas redes sociais para que mais pessoas possam desfrutar desta ferramenta e alguém possa nos apoiar."
    },
    COPY_CROSSHAIR: {
        en: "Copy Crosshair",
        es: "Copiar Crosshair",
        pt: "Copiar Crosshair"
    },
    COPY_VIEWMODEL: {
        en: "Copy Viewmodel",
        es: "Copiar Viewmodel",
        pt: "Copiar Viewmodel"
    },
    COPIED: {
        en: "Copied",
        es: "Copiado",
        pt: "Copiado"
    },
    CFG_LABEL: {
        en: "To paste into your .cfg / autoexec.cfg file",
        es: "Para pegar en tu archivo .cfg / autoexec.cfg",
        pt: "Para colar no seu arquivo .cfg / autoexec.cfg"
    },
    CONSOLE_LABEL: {
        en: "To paste into console (Separated by ;)",
        es: "Para pegar en la consola (Separado por ;)",
        pt: "Para colar no console (Separado por ;)"
    },
    COPY_ALL: {
        en: "Copy All",
        es: "Copiar Todo",
        pt: "Copiar Tudo"
    },

    // Mouse Module
    MOUSE_DESC: {
        en: "Adjusts the overall mouse sensitivity.",
        es: "Ajusta la sensibilidad general del mouse.",
        pt: "Ajusta la sensibilidad general del mouse."
    },
    MOUSE_SENSITIVITY_TITLE: {
        en: "Mouse & Sensitivity",
        es: "Mouse y Sensibilidad",
        pt: "Mouse y Sensibilidad"
    },
    SENSITIVITY: {
        en: "Sensitivity",
        es: "Sensibilidad",
        pt: "Sensibilidad"
    },
    SENSITIVITY_DESC: {
        en: "Adjusts the overall mouse sensitivity.",
        es: "Ajusta la sensibilidad general del mouse.",
        pt: "Ajusta la sensibilidad general del mouse."
    },
    ELECTRON_WELCOME_TITLE: {
        en: "Initial Setup",
        es: "Configuración Inicial",
        pt: "Configuração Inicial"
    },
    ELECTRON_WELCOME_MSG_1: {
        en: "Welcome to ConfigStrike! Before we start, we need to find the CS2 configuration folder to save your settings.",
        es: "¡Bienvenido a ConfigStrike! Antes de comenzar, necesitamos encontrar la carpeta de configuración de CS2 para guardar tus ajustes.",
        pt: "Bem-vindo ao ConfigStrike! Antes de começar, precisamos encontrar a pasta de configuração do CS2 para salvar suas configurações."
    },
    ELECTRON_WELCOME_SEARCHING: {
        en: "Searching for CS2 installation...",
        es: "Buscando instalación de CS2...",
        pt: "Procurando instalação do CS2..."
    },
    ELECTRON_WELCOME_FOUND: {
        en: "CS2 folder found!",
        es: "¡Carpeta de CS2 encontrada!",
        pt: "Pasta do CS2 encontrada!"
    },
    ELECTRON_WELCOME_NOT_FOUND: {
        en: "Could not find CS2 folder automatically.",
        es: "No se pudo encontrar la carpeta de CS2 automáticamente.",
        pt: "Não foi possível encontrar a pasta do CS2 automaticamente."
    },
    ELECTRON_WELCOME_CFG_PATH_LABEL: {
        en: "Configuration files will be saved to:",
        es: "Los archivos de configuración se guardarán en:",
        pt: "Os arquivos de configuração serão salvos em:"
    },
    ELECTRON_WELCOME_AUTO_DETECT_BTN: {
        en: "Auto-Detect CS2 Folder",
        es: "Detectar Carpeta de CS2",
        pt: "Detectar Pasta do CS2"
    },
    ELECTRON_WELCOME_MANUAL_BTN: {
        en: "Select Folder Manually",
        es: "Seleccionar Carpeta Manualmente",
        pt: "Selecionar Pasta Manualmente"
    },
    ELECTRON_WELCOME_MANUAL_TOOLTIP: {
        en: "If automatic detection fails, you can manually select the CS2 cfg folder (usually in Steam\\steamapps\\common\\Counter-Strike Global Offensive\\game\\csgo\\cfg)",
        es: "Si la detección automática falla, puedes seleccionar manualmente la carpeta cfg de CS2 (normalmente en Steam\\steamapps\\common\\Counter-Strike Global Offensive\\game\\csgo\\cfg)",
        pt: "Se a detecção automática falhar, você pode selecionar manualmente a pasta cfg do CS2 (geralmente em Steam\\steamapps\\common\\Counter-Strike Global Offensive\\game\\csgo\\cfg)"
    },
    ELECTRON_WELCOME_BACKUP_INFO: {
        en: "We will automatically backup your original autoexec.cfg before making any changes.",
        es: "Haremos un backup automático de tu autoexec.cfg original antes de hacer cualquier cambio.",
        pt: "Faremos backup automático do seu autoexec.cfg original antes de fazer qualquer alteração."
    },
    ELECTRON_WELCOME_CONFIRM_BTN: {
        en: "Confirm & Continue",
        es: "Confirmar y Continuar",
        pt: "Confirmar e Continuar"
    },
    ELECTRON_WELCOME_DONT_SHOW: {
        en: "Do not show this message again",
        es: "No volver a mostrar este mensaje",
        pt: "Não mostrar esta mensagem novamente"
    },
    ELECTRON_WELCOME_RETRY_BTN: {
        en: "Try Again",
        es: "Reintentar",
        pt: "Tentar Novamente"
    },
    ZOOM_SENSITIVITY: {
        en: "Zoom Sensitivity",
        es: "Sensibilidad de Zoom",
        pt: "Sensibilidad de Zoom"
    },
    ZOOM_SENSITIVITY_DESC: {
        en: "Sensitivity multiplier when using scope (zoom).",
        es: "Multiplicador de sensibilidad al usar la mira (zoom).",
        pt: "Multiplicador de sensibilidad al usar la mira (zoom)."
    },
    RAW_INPUT: {
        en: "Raw Input",
        es: "Entrada Directa (Raw Input)",
        pt: "Entrada Directa (Raw Input)"
    },
    RAW_INPUT_DESC: {
        en: "Uses direct mouse input, bypassing Windows settings.",
        es: "Usa la entrada directa del mouse, ignorando la configuración de Windows.",
        pt: "Usa la entrada directa del mouse, ignorando la configuração de Windows."
    },
    SNIPER_WIDTH: {
        en: "Sniper Width",
        es: "Linea Sniper",
        pt: "Linea Sniper"
    },
    SNIPER_WIDTH_DESC: {
        en: "Thickness of the sniper crosshair lines.",
        es: "Grosor de las líneas de la mira del francotirador.",
        pt: "Grosor de las líneas de la mira del francotirador."
    },
    M_YAW: {
        en: "m_yaw (Horizontal Sensibility)",
        es: "m_yaw (Sensibilidad Horizontal)",
        pt: "m_yaw (Sensibilidad Horizontal)"
    },
    M_YAW_DESC: {
        en: "Adjusts horizontal sensitivity. Default 0.022. Useful for 4:3 stretched (0.0165).",
        es: "Ajusta la sensibilidad horizontal. Defecto 0.022. Útil para 4:3 stretched (0.0165).",
        pt: "Ajusta la sensibilidad horizontal. Defecto 0.022. Útil para 4:3 stretched (0.0165)."
    },
    DPI: {
        en: "Mouse DPI",
        es: "DPI del Mouse",
        pt: "DPI del Mouse"
    },
    IMPORTANT_ENTER_DPI: {
        en: "IMPORTANT: PLEASE ENTER YOUR REAL MOUSE DPI",
        es: "IMPORTANTE: POR FAVOR INGRESÁ TUS DPI REALES",
        pt: "IMPORTANTE: POR FAVOR INSIRA O DPI REAL DO SEU MOUSE"
    },
    DPI_DESC: {
        en: "Your mouse hardware DPI. Used to calculate eDPI.",
        es: "El DPI de tu mouse. Se usa para calcular el eDPI.",
        pt: "El DPI de tu mouse. Se usa para calcular el eDPI."
    },
    EDPI: {
        en: "eDPI",
        es: "eDPI",
        pt: "eDPI"
    },
    EDPI_DESC: {
        en: "eDPI is the value obtained from the multiplication of the mouse DPI with the game sensitivity. Use it to easily compare your settings with other players.",
        es: "El eDPI es el valor obtenido de la multiplicación de los DPI del mouse con tu sensibilidad del juego. Úsalo para comparar tu configuración fácilmente con otros jugadores.",
        pt: "El eDPI es el valor obtenido de la multiplicação de los DPI del mouse con tu sensibilidad del juego. Úsalo para comparar tu configuração fácilmente con otros jugadores."
    },
    EDPI_RECOMMENDED: {
        en: "Recommended competitive range:",
        es: "Rango competitivo recomendado:",
        pt: "Rango competitivo recomendado:"
    },
    YOUR_EDPI: {
        en: "YOUR EDPI",
        es: "TU eDPI",
        pt: "TU eDPI"
    },
    MOUSE_HARDWARE_DPI: {
        en: "Mouse Hardware DPI",
        es: "El DPI de tu MOUSE",
        pt: "El DPI de tu MOUSE"
    },
    TARGET_EDPI: {
        en: "Target eDPI",
        es: "eDPI Objetivo",
        pt: "eDPI Objetivo"
    },
    REQ_SENS: {
        en: "Req. Sens",
        es: "Sens. Requerida",
        pt: "Sens. Requerida"
    },
    APPLY: {
        en: "APPLY",
        es: "APLICAR",
        pt: "APLICAR"
    },
    CALC_TITLE: {
        en: "Calculate your sensitivity!",
        es: "¡Calcula tu sensibilidad!",
        pt: "¡Calcula tu sensibilidad!"
    },
    CALC_DPI_DESC: {
        en: "Set your mouse hardware DPI here.",
        es: "Pone aca los DPIs que para jugar en tu mouse",
        pt: "Pone aca los DPIs que para jugar en tu mouse"
    },
    CALC_TARGET_DESC: {
        en: "Enter your target eDPI (1000 recommended).",
        es: "Pone los eDPPI que quieres tener, 1000 recomendado",
        pt: "Pone los eDPPI que quieres tener, 1000 recomendado"
    },
    MOUSE_PRESET_AIM_MAX_TITLE: {
        en: "Aim Maximized",
        es: "Aim Maximized",
        pt: "Aim Maximized"
    },
    MOUSE_PRESET_AIM_MAX_DESC: {
        en: "Low sensitivity for maximum precision (eDPI: 700)",
        es: "Baja sensibilidad para máxima precisión (eDPI: 700)",
        pt: "Baixa sensibilidade para máxima precisão (eDPI: 700)"
    },
    MOUSE_PRESET_AGILE_TITLE: {
        en: "Agile",
        es: "Agile",
        pt: "Agile"
    },
    MOUSE_PRESET_AGILE_DESC: {
        en: "High mobility and fast turns (eDPI: 1200)",
        es: "Alta movilidad y giros rápidos (eDPI: 1200)",
        pt: "Alta mobilidade e giros rápidos (eDPI: 1200)"
    },
    MOUSE_PRESET_PRO_STD_TITLE: {
        en: "Pro Player Standard",
        es: "Pro Player Standard",
        pt: "Pro Player Standard"
    },
    MOUSE_PRESET_PRO_STD_DESC: {
        en: "The most used setup (eDPI: 900)",
        es: "La configuración más usada (eDPI: 900)",
        pt: "A configuração mais usada (eDPI: 900)"
    },
    MOUSE_PRESET_NOVICE_TITLE: {
        en: "Novice",
        es: "Novice",
        pt: "Novice"
    },
    MOUSE_PRESET_NOVICE_DESC: {
        en: "High sensitivity recommended if you have little desk space (eDPI: 1600)",
        es: "Sensibilidad alta recomendada si tienes poco espacio (eDPI: 1600)",
        pt: "Sensibilidade alta recomendada se você tem pouco espaço (eDPI: 1600)"
    },
    MOUSE_PRESETS_DPI_LABEL: {
        en: "CALCULATED BASED ON YOUR MOUSE DPI:",
        es: "CALCULADO EN BASE A TU DPI:",
        pt: "CALCULADO COM BASE NO SEU DPI:"
    },

    // Crosshair Module
    CROSSHAIR_TITLE: {
        en: "Crosshair",
        es: "Mira/Crosshair",
        pt: "Mira/Crosshair"
    },
    CROSSHAIR_DESC: {
        en: "Customize your CS:GO/CS2 crosshair.",
        es: "Personaliza tu mira de CS:GO/CS2.",
        pt: "Personalize sua mira de CS:GO/CS2."
    },
    SIZE: {
        en: "Size",
        es: "Tamaño",
        pt: "Tamaño"
    },
    SIZE_DESC: {
        en: "Controls the length of the crosshair lines.",
        es: "Controla la longitud de las líneas de la mira.",
        pt: "Controla la longitud de las líneas de la mira."
    },
    GENERAL: {
        en: "General",
        es: "General",
        pt: "General"
    },
    COLOR: {
        en: "Color",
        es: "Color",
        pt: "Color"
    },
    OUTLINE_GROUP: {
        en: "Outline",
        es: "Contorno",
        pt: "Contorno"
    },
    THICKNESS: {
        en: "Thickness",
        es: "Grosor",
        pt: "Grosor"
    },
    THICKNESS_DESC: {
        en: "Defines the width of the crosshair lines.",
        es: "Define el ancho de las líneas de la mira.",
        pt: "Define el ancho de las líneas de la mira."
    },
    GAP: {
        en: "Gap",
        es: "Apertura",
        pt: "Apertura"
    },
    GAP_DESC: {
        en: "Adjusts the distance between the center lines.",
        es: "Ajusta la distancia entre las líneas centrales.",
        pt: "Ajusta la distancia entre las líneas centrales."
    },
    CENTER_DOT: {
        en: "Center Dot",
        es: "Punto Central",
        pt: "Punto Central"
    },
    CENTER_DOT_DESC: {
        en: "Enables or disables the dot at the center of the crosshair.",
        es: "Activa o desactiva el punto en el centro de la mira.",
        pt: "Activa o desactiva el punto en el centro de la mira."
    },
    STYLE: {
        en: "Style",
        es: "Estilo",
        pt: "Estilo"
    },
    STYLE_DESC: {
        en: "Changes the crosshair behavior (Static, Dynamic, etc.).",
        es: "Cambia el comportamiento de la mira (Estático, Dinámico, etc.).",
        pt: "Cambia el comportamiento de la mira (Estático, Dinámico, etc.)."
    },
    OPACITY: {
        en: "Opacity",
        es: "Opacidad",
        pt: "Opacidad"
    },
    OPACITY_DESC: {
        en: "Adjusts the transparency of the crosshair (255 is solid).",
        es: "Ajusta la transparencia de la mira (255 es sólido).",
        pt: "Ajusta la transparencia de la mira (255 es sólido)."
    },
    OUTLINE: {
        en: "Outline",
        es: "Contorno",
        pt: "Contorno"
    },
    OUTLINE_DESC: {
        en: "Enables a black outline around the crosshair for better contrast.",
        es: "Habilita un contorno negro alrededor de la mira para mejorar el contraste.",
        pt: "Habilita un contorno negro alrededor de la mira para mejorar el contraste."
    },
    OUTLINE_THICKNESS: {
        en: "Outline Thickness",
        es: "Grosor del Contorno",
        pt: "Grosor del Contorno"
    },
    OUTLINE_THICKNESS_DESC: {
        en: "Controls the width of the black outline.",
        es: "Controla el ancho del contorno negro.",
        pt: "Controla el ancho del contorno negro."
    },
    RED: {
        en: "Red",
        es: "Rojo",
        pt: "Rojo"
    },
    RED_DESC: {
        en: "Amount of red in the color.",
        es: "Cantidad de rojo en el color.",
        pt: "Cantidad de rojo en el color."
    },
    GREEN: {
        en: "Green",
        es: "Verde",
        pt: "Verde"
    },
    GREEN_DESC: {
        en: "Amount of green in the color.",
        es: "Cantidad de verde en el color.",
        pt: "Cantidad de verde en el color."
    },
    BLUE: {
        en: "Blue",
        es: "Azul",
        pt: "Azul"
    },
    BLUE_DESC: {
        en: "Amount of blue in the color.",
        es: "Cantidad de azul en el color.",
        pt: "Cantidad de azul en el color."
    },
    CS2_ENHANCEMENTS: {
        en: "CS2 Enhancements",
        es: "Mejoras de CS2"
    },
    FOLLOW_RECOIL: {
        en: "Follow Recoil",
        es: "Seguir Recoil",
        pt: "Seguir Recoil"
    },
    FOLLOW_RECOIL_DESC: {
        en: "The crosshair follows the weapon's spray pattern.",
        es: "La mira sigue el patrón de disparo (spray) del arma.",
        pt: "La mira sigue el patrón de disparo (spray) del arma."
    },
    T_CROSSHAIR: {
        en: "T-Style Crosshair",
        es: "Mira Estilo T",
        pt: "Mira Estilo T"
    },
    T_CROSSHAIR_DESC: {
        en: "Removes the top line of the crosshair.",
        es: "Elimina la línea superior de la mira.",
        pt: "Elimina la línea superior de la mira."
    },
    FRIENDLY_WARNING: {
        en: "Friendly Fire Warning",
        es: "Aviso fuego amigo",
        pt: "Aviso fuego amigo"
    },
    FRIENDLY_WARNING_DESC: {
        en: "Changes crosshairs look when aiming at teammates.",
        es: "Cambia la mira al apuntar a compañeros de equipo.",
        pt: "Cambia la mira al apuntar a compañeros de equipo."
    },
    FRIENDLY_FIRE_WARNING: {
        en: "Friendly Fire Warning",
        es: "Aviso fuego amigo",
        pt: "Aviso fuego amigo"
    },
    STATIC: {
        en: "Static",
        es: "Estática",
        pt: "Estática"
    },
    DYNAMIC: {
        en: "Dynamic",
        es: "Dinámica",
        pt: "Dinámica"
    },
    RECOIL: {
        en: "Recoil",
        es: "Retroceso",
        pt: "Retroceso"
    },
    ZOOM: {
        en: "Zoom",
        es: "Zoom",
        pt: "Zoom"
    },
    HOLD_TO_ZOOM: {
        en: "Hold to zoom",
        es: "Mantén para zoom",
        pt: "Mantén para zoom"
    },
    RESET_ZOOM: {
        en: "Temporal zoom",
        es: "Zoom temporal",
        pt: "Zoom temporal"
    },
    COPY_TO_CONSOLE: {
        en: "Copy to console",
        es: "Copiar a consola",
        pt: "Copiar a consola"
    },
    COPY_TO_CONSOLE_DESC: {
        en: "Copy the commands listos para pegarlos en la Consola de CS2.",
        es: "Copia los comandos listos para pegarlos en la Consola de CS2.",
        pt: "Copia los comandos listos para pegarlos en la Consola de CS2."
    },
    COPY_TO_CONSOLE_DESC_QUICK: {
        en: "Copy commands",
        es: "Copia comandos",
        pt: "Copia comandos"
    },
    CUSTOM_COLOR: {
        en: "Custom Color",
        es: "Color Personalizado",
        pt: "Color Personalizedo"
    },
    PRO_SENSE: {
        en: "Pro & Presets",
        es: "Pro y Ajustes",
        pt: "Pro y Ajustes"
    },
    PRO_PLAYER_PRESETS: {
        en: "Pro Player Presets",
        es: "Presets de Jugadores Pro",
        pt: "Presets de Jugadores Pro"
    },
    SPECIALS_LABEL: {
        en: "Specials",
        es: "Especiales",
        pt: "Especiales"
    },

    // Home Page
    COMMUNITY: {
        en: "Community",
        es: "Comunidad",
        pt: "Comunidad"
    },
    GUIDES: {
        en: "Guides",
        es: "Guías",
        pt: "Guías"
    },
    PRO_PLAYERS: {
        en: "Pro Players",
        es: "Jugadores Pro",
        pt: "Jugadores Pro"
    },
    COMING_SOON_STEAM: {
        en: "Coming Soon: Login with Steam",
        es: "Próximamente: Inicia sesión con Steam",
        pt: "Próximamente: Fazer login con Steam"
    },
    HERO_TITLE: {
        en: "Configure like a Pro. Play like a Legend.",
        es: "Configura como un Pro. Juega como una Leyenda.",
        pt: "Configure como um Pro. Juega como una Leyenda."
    },
    HERO_SUBTITLE: {
        en: "The most advanced CS2 config builder. Visualize, customize, and export your perfect setup in seconds.",
        es: "El creador de cfgs de CS2 más avanzado. Visualiza, personaliza y exporta tu configuración perfecta en segundos.",
        pt: "El creador de cfgs de CS2 más avanzado. Visualiza, personaliza y exporta tu configuração perfecta en segundos."
    },
    CREATE_MY_CONFIG: {
        en: "CREATE MY CONFIG",
        es: "CREAR MI CONFIG",
        pt: "CREAR MI CONFIG"
    },
    VISUAL_EDITOR: {
        en: "Visual Editor",
        es: "Editor Visual",
        pt: "Editor Visual"
    },
    VISUAL_EDITOR_DESC: {
        en: "Forget the console. Adjust your crosshair, sensitivity, and binds with an intuitive interface and real-time preview.",
        es: "Olvídate de la consola. Ajusta tu crosshair, sensibilidad y binds con una interfaz intuitiva y preview en tiempo real.",
        pt: "Olvídate de la consola. Ajusta tu crosshair, sensibilidad y binds con una interfaz intuitiva y preview em tempo real."
    },
    CLOUD_SYNC_DESC: {
        en: "Save your configurations in the cloud. Access them from any PC and never lose your autoexec.",
        es: "Guarda tus configuraciones en la nube. Accede a ellas desde cualquier PC y nunca pierdas tu autoexec.",
        pt: "Guarda tus configurações en la nube. Accede a ellas desde cualquier PC y nunca pierdas tu autoexec."
    },
    SECURE_100: {
        en: "100% Secure",
        es: "100% Seguro"
    },
    SECURE_100_DESC: {
        en: "We generate clean, optimized .cfg code, ready to paste into your CS2 folder. No weird executables.",
        es: "Generamos código .cfg limpio y optimizado, listo para pegar en tu carpeta de CS2. Sin ejecutables extraños."
    },
    COMMUNITY_CONFIGS: {
        en: "Community Configs",
        es: "Configs de la Comunidad",
        pt: "Configs de la Comunidad"
    },
    COMMUNITY_CONFIGS_DESC: {
        en: "Inspiration from the best players",
        es: "Inspiración de los mejores jugadores",
        pt: "Inspiração de los mejores jugadores"
    },
    VIEW_ALL: {
        en: "View all",
        es: "Ver todas",
        pt: "Ver todas"
    },
    DOWNLOADS: {
        en: "downloads",
        es: "descargas",
        pt: "descargas"
    },

    // SideNav
    HOME: {
        en: "Home",
        es: "Inicio",
        pt: "Inicio"
    },
    CONFIGURATION: {
        en: "Configuration",
        es: "Configuración",
        pt: "Configuração"
    },
    ABOUT: {
        en: "About",
        es: "Acerca de",
        pt: "Acerca de"
    },

    // Welcome Guide
    WELCOME_TO_APP: {
        en: "Welcome to our application",
        es: "Bienvenido a nuestra aplicación",
        pt: "Bienvenido a nuestra aplicação"
    },
    SET_UP_PROFILE: {
        en: "Set up your profile",
        es: "Configura tu perfil",
        pt: "Configura tu perfil"
    },
    EXPLORE_FEATURES: {
        en: "Explore technical features",
        es: "Explora las funcionalidades",
        pt: "Explora las funcionalidades"
    },
    GET_STARTED: {
        en: "Get started",
        es: "Comienza a usarla",
        pt: "Comienza a usarla"
    },
    YOU_CLICKED_STEP: {
        en: "You clicked on step",
        es: "Has clicado en el paso",
        pt: "Has clicado en el paso"
    },

    // Crosshair Wiki
    WIKI_TITLE: {
        en: "CS2 Crosshair Commands",
        es: "Comandos de Mira en CS2",
        pt: "Comandos de Mira en CS2"
    },
    WIKI_INTRO: {
        en: "In Counter-Strike 2 (CS2), crosshair customization is essential to improve accuracy and adapt it to your gameplay preferences. Below, we offer a complete description of all commands you can use to modify the crosshair through the console, along with a detailed explanation of each one.",
        es: "En Counter-Strike 2 (CS2), la personalización de la mira es esencial para mejorar la precisión y adaptarla a tus preferencias de juego. A continuación, te ofrecemos una descripción completa de todos los comandos que puedes utilizar para modificar la mira a través de la consola, junto con una explicación detallada de cada uno.",
        pt: "En Counter-Strike 2 (CS2), la personalização de la mira es esencial para mejorar la precisión y adaptarla a tus preferencias de juego. A continuação, te ofrecemos una descripção completa de todos los comandos que puedes utilizar para modificar la mira a través de la consola, junto con una explicação detallada de cada uno."
    },
    CROSSHAIR_STYLES: {
        en: "Crosshair Styles",
        es: "Estilos de la Mira",
        pt: "Estilos de la Mira"
    },
    STYLES_DESC: {
        en: "This command allows you to select the overall crosshair style. The available styles are:",
        es: "Este comando permite seleccionar el estilo general de la mira. Los estilos disponibles son:",
        pt: "Este comando permite seleccionar el estilo general de la mira. Los estilos disponibles son:"
    },
    STYLE_0: {
        en: "0 - Default Dynamic: Expands when you move or shoot.",
        es: "0 - Mira dinámica por defecto: Se expande cuando te mueves o disparas."
    },
    STYLE_1: {
        en: "1 - Default Static: Does not expand (not available in CS2).",
        es: "1 - Mira estática por defecto: No se expande (no disponible en CS2)."
    },
    STYLE_2: {
        en: "2 - Classic Dynamic: Expands/contracts based on movement.",
        es: "2 - Mira clásica dinámica: Se expande/contrae según el movimiento."
    },
    STYLE_3: {
        en: "3 - Classic Dynamic: Not fully implemented.",
        es: "3 - Mira clásica dinámica: No completamente implementada."
    },
    STYLE_4: {
        en: "4 - Classic Static: Does not expand.",
        es: "4 - Mira clásica estática: No se expande."
    },
    STYLE_5: {
        en: "5 - Dynamic with less expansion.",
        es: "5 - Mira dinámica con menor expansión."
    },
    DEFAULT_VALUES: {
        en: "Default values for",
        es: "Valores por defecto para",
        pt: "Valores por defecto para"
    },
    CLICK_TO_COPY: {
        en: "Click to copy",
        es: "Haz clic para copiar",
        pt: "Haz clic para copiar"
    },
    COPIED: {
        en: "Copied!",
        es: "¡Copiado!",
        pt: "¡Copiado!"
    },
    COLOR_ADJUSTMENTS: {
        en: "Color Adjustment Commands",
        es: "Comandos para Ajustes de Color",
        pt: "Comandos para Ajustes de Color"
    },
    COLOR_DESC: {
        en: "This command changes the crosshair color. The values are:",
        es: "Este comando cambia el color de la mira. Los valores son:",
        pt: "Este comando cambia el color de la mira. Los valores son:"
    },
    RGB_DESC: {
        en: "Adjusts RGB values for color customization. The maximum values are 255 for each color (Red, Green, Blue).",
        es: "Ajusta los valores RGB para personalizar el color. Los valores máximos son 255 para cada color (Rojo, Verde, Azul).",
        pt: "Ajusta los valores RGB para personalizar el color. Los valores máximos son 255 para cada color (Rojo, Verde, Azul)."
    },
    SIZE_DESC_WIKI: {
        en: "Controls the size of the lines that form the crosshair. The default value is 5 and you can adjust it between -20 and 20.",
        es: "Controla el tamaño de las líneas que forman la mira. El valor por defecto es 5 y puedes ajustarlo entre -20 y 20.",
        pt: "Controla el tamaño de las líneas que forman la mira. El valor por defecto es 5 y puedes ajustarlo entre -20 y 20."
    },
    THICKNESS_DESC_WIKI: {
        en: "Adjusts the thickness of the crosshair lines. The default value is 0.5, with a range from -2 to 6.",
        es: "Ajusta el grosor de las líneas de la mira. El valor por defecto es 0.5, con un rango de -2 a 6.",
        pt: "Ajusta el grosor de las líneas de la mira. El valor por defecto es 0.5, con un rango de -2 a 6."
    },
    ALPHA_DESC_WIKI: {
        en: "Controls the crosshair transparency. The default value is 200, with a range between 10 and 250.",
        es: "Controla la transparencia de la mira. El valor por defecto es 200, con un rango entre 10 y 250.",
        pt: "Controla la transparencia de la mira. El valor por defecto es 200, con un rango entre 10 y 250."
    },
    GAP_DESC_WIKI: {
        en: "Adjusts the space between the crosshair lines. The default value is 1, with a range between -10 and 10.",
        es: "Ajusta el espacio entre las líneas de la mira. El valor por defecto es 1, con un rango entre -10 y 10.",
        pt: "Ajusta el espacio entre las líneas de la mira. El valor por defecto es 1, con un rango entre -10 y 10."
    },
    GAP_WEAPON_DESC: {
        en: "Dynamically adjusts the gap size based on the weapon you are using. Use 1 to enable and 0 to disable.",
        es: "Ajusta dinámicamente el tamaño del gap según el arma que estés usando. Usa 1 para activarlo y 0 para desactivarlo.",
        pt: "Ajusta dinámicamente el tamaño del gap según el arma que estés usando. Usa 1 para activarlo y 0 para desactivarlo."
    },
    DYNAMIC_INNER_DESC: {
        en: "Adjusts the transparency of the inner part of the crosshair with style 2. Values range from 0 to 1.",
        es: "Ajusta la transparencia de la parte interna de la mira con el estilo 2. Los valores van de 0 a 1.",
        pt: "Ajusta la transparencia de la parte interna de la mira con el estilo 2. Los valores van de 0 a 1."
    },
    DYNAMIC_OUTER_DESC: {
        en: "Adjusts the transparency of the outer part of the crosshair in style 2. Values range from 0.3 to 1.",
        es: "Ajusta la transparencia de la parte externa de la mira en el estilo 2. Los valores van de 0.3 a 1.",
        pt: "Ajusta la transparencia de la parte externa de la mira en el estilo 2. Los valores van de 0.3 a 1."
    },
    DOT_DESC: {
        en: "Adds a dot in the center of the crosshair. Use 1 to enable and 0 to disable.",
        es: "Añade un punto en el centro de la mira. Usa 1 para activarlo y 0 para desactivarlo.",
        pt: "Añade un punto en el centro de la mira. Usa 1 para activarlo y 0 para desactivarlo."
    },
    SNIPER_WIDTH_DESC_WIKI: {
        en: "Adjusts the thickness of the crosshair lines when using sniper rifles. The default value is 1, with a range from 0 to 20.",
        es: "Ajusta el grosor de las líneas de la mira cuando usas rifles de francotirador. El valor por defecto es 1, con un rango de 0 a 20.",
        pt: "Ajusta el grosor de las líneas de la mira cuando usas rifles de francotirador. El valor por defecto es 1, con un rango de 0 a 20."
    },
    CFG_STRIKE_TITLE: {
        en: "CONFIG-STRIKE - CONFIG CREATOR",
        es: "CONFIG-STRIKE - CREADOR DE CONFIGURACIÓN",
        pt: "CONFIG-STRIKE - CREADOR DE CONFIGURACIÓN"
    },
    CFG_INSTRUCTIONS: {
        en: "INSTRUCTIONS:",
        es: "INSTRUCCIONES:",
        pt: "INSTRUCCIONES:"
    },
    CFG_STEP_1: {
        en: "1. Move to \"cfg\" folder:",
        es: "1. Mover a la carpeta \"cfg\":"
    },
    CFG_STEP_2: {
        en: "2. Execute command: \"exec {your-cfg}\" or add",
        es: "2. Ejecutar comando: \"exec {tu-cfg}\" o añadir"
    },
    CFG_STEP_2_LAUNCH: {
        en: "\"+exec {your-cfg}\" to launch options.",
        es: "\"+exec {tu-cfg}\" a los parámetros de lanzamiento."
    },
    YOUR_CONFIGS_CFG: {
        en: "YOUR CONFIGURATIONS:",
        es: "TUS CONFIGURACIONES:",
        pt: "TUS CONFIGURACIONES:"
    },
    SIZE_THICK_TRANS: {
        en: "Size, Thickness, and Transparency",
        es: "Tamaño, Grosor y Transparencia",
        pt: "Tamaño, Grosor y Transparencia"
    },
    GAP_MODIFICATION: {
        en: "Gap Modification (Space between lines)",
        es: "Modificación del Gap (Espacio entre las líneas)",
        pt: "Modificação del Gap (Espacio entre las líneas)"
    },
    CROSSHAIR_DYNAMISM: {
        en: "Crosshair Dynamism",
        es: "Dinamismo de la Mira",
        pt: "Dinamismo de la Mira"
    },
    OTHER_DETAILS: {
        en: "Other Additional Details",
        es: "Otros Detalles Adicionales",
        pt: "Otros Detalles Adicionales"
    },

    // HUD & Radar Module
    HUD_RADAR_TITLE: {
        en: "HUD & Radar",
        es: "HUD y Radar",
        pt: "HUD y Radar"
    },
    HUD_RADAR_DESC: {
        en: "Customize your HUD colors, scaling, and radar behavior.",
        es: "Personaliza los colores de tu interfaz, escalas y comportamiento del radar.",
        pt: "Personalize los colores de tu interfaz, escalas y comportamiento del radar."
    },
    HUD_COLOR_LABEL: {
        en: "HUD Color",
        es: "Color del HUD",
        pt: "Color del HUD"
    },
    HUD_COLOR_DESC_HELP: {
        en: "Changes the overall color of your interface elements.",
        es: "Cambia el color global de los elementos de tu interfaz.",
        pt: "Cambia el color global de los elementos de tu interfaz."
    },
    HUD_SCALE_LABEL: {
        en: "HUD Scale",
        es: "Escala del HUD",
        pt: "Escala del HUD"
    },
    HUD_SCALE_DESC_HELP: {
        en: "Overall scale of the HUD elements (health, ammo, etc).",
        es: "Escala general de los elementos del HUD (vida, balas, etc).",
        pt: "Escala general de los elementos del HUD (vida, balas, etc)."
    },
    RADAR_SCALE_LABEL: {
        en: "Radar Scale (Zoom)",
        es: "Escala del Radar (Zoom)",
        pt: "Escala del Radar (Zoom)"
    },
    RADAR_SCALE_DESC_HELP: {
        en: "Zoom level of the map inside the radar.",
        es: "Nivel de zoom del mapa dentro del radar.",
        pt: "Nivel de zoom del mapa dentro del radar."
    },
    RADAR_HUD_SIZE_LABEL: {
        en: "Radar HUD Size",
        es: "Tamaño del Radar en HUD",
        pt: "Tamaño del Radar en HUD"
    },
    RADAR_HUD_SIZE_DESC_HELP: {
        en: "Size of the radar circle on your screen.",
        es: "Tamaño del círculo del radar en tu pantalla.",
        pt: "Tamaño del círculo del radar en tu pantalla."
    },
    RADAR_CENTERED_LABEL: {
        en: "Always Centered Radar",
        es: "Radar Siempre Centrado",
        pt: "Radar Siempre Centrado"
    },
    RADAR_ROTATE_LABEL: {
        en: "Rotate Radar",
        es: "Rotar Radar",
        pt: "Rotar Radar"
    },
    SHOW_LOADOUT_LABEL: {
        en: "Always Show Inventory",
        es: "Mostrar Siempre Inventario",
        pt: "Mostrar Siempre Inventario"
    },
    RADAR_ICON_SCALE_LABEL: {
        en: "Radar Icon Scale",
        es: "Escala Iconos Radar",
        pt: "Escala Iconos Radar"
    },
    RADAR_ICON_SCALE_DESC_HELP: {
        en: "Minimum scale for the radar icons (teammates, bomb).",
        es: "Escala mínima de los iconos del radar (compañeros, bomba).",
        pt: "Escala mínima de los iconos del radar (compañeros, bomba)."
    },
    TEAMMATE_COLORS_LABEL: {
        en: "Teammate Colors on Radar",
        es: "Colores de Compañeros en Radar",
        pt: "Colores de Compañeros en Radar"
    },
    TEAMMATE_COLORS_DESC_HELP: {
        en: "0: No colors, 1: Show colors, 2: Show colors and letters.",
        es: "0: Sin colores, 1: Mostrar colores, 2: Colores y letras.",
        pt: "0: Sin colores, 1: Mostrar colores, 2: Colores y letras."
    },
    RADAR_OPACITY_LABEL: {
        en: "Radar Opacity",
        es: "Opacidad del Radar",
        pt: "Opacidad del Radar"
    },
    RADAR_OPACITY_DESC_HELP: {
        en: "Controls the transparency of the radar background circle.",
        es: "Controla la transparencia del fondo del círculo del radar.",
        pt: "Controla la transparencia del fondo del círculo del radar."
    },
    RADAR_BIG_BIND_LABEL: {
        en: "Big Radar (Hold)",
        es: "Radar Gigante (Mantener)",
        pt: "Radar Gigante (Mantener)"
    },
    RADAR_BIG_BIND_DESC_HELP: {
        en: "When pressed, the radar enlarges to its maximum size and the zoom level is reduced to allow a quick glance at the entire map.",
        es: "Al presionar esta tecla el radar se agranda a su máximo posible y el zoom se aleja para poder dar un vistazo rápido a todo el mapa.",
        pt: "Al presionar esta tecla el radar se agranda a su máximo posible y el zoom se aleja para poder dar un vistazo rápido a todo el mapa."
    },
    RADAR_OVERVIEW_BIND_LABEL: {
        en: "Radar Overview (Toggle)",
        es: "Vista General del Radar (Toggle)",
        pt: "Vista General del Radar (Toggle)"
    },
    RADAR_OVERVIEW_BIND_DESC_HELP: {
        en: "Toggle between your current radar zoom and seeing the whole map.",
        es: "Alterna entre tu zoom actual y ver todo el mapa completo.",
        pt: "Alterna entre tu zoom actual y ver todo el mapa completo."
    },
    RADAR_COMPACT_TITLE: {
        en: "Compact",
        es: "Compacto",
        pt: "Compacto"
    },
    RADAR_COMPACT_DESC: {
        en: "Small radar with wide map vision.",
        es: "Radar pequeño con visión amplia del mapa.",
        pt: "Radar pequeno com visão ampla do mapa."
    },
    RADAR_BALANCED_TITLE: {
        en: "Balanced",
        es: "Balanceado",
        pt: "Balanceado"
    },
    RADAR_BALANCED_DESC: {
        en: "Balance between size and visibility.",
        es: "Equilibrio entre tamaño y visibilidad.",
        pt: "Equilíbrio entre tamanho e visibilidade."
    },
    RADAR_COMPETITIVE_TITLE: {
        en: "Competitive (Pro)",
        es: "Competitivo (Pro)",
        pt: "Competitivo (Pro)"
    },
    RADAR_COMPETITIVE_DESC: {
        en: "Standard setting used by pros.",
        es: "Estándar usado por profesionales.",
        pt: "Padrão usado por profissionais."
    },
    RADAR_GIANT_TITLE: {
        en: "Giant Vision",
        es: "Visión Gigante",
        pt: "Visão Gigante"
    },
    RADAR_GIANT_DESC: {
        en: "Max size and zoom (Novice friendly).",
        es: "Máximo tamaño y zoom (Novice).",
        pt: "Tamanho e zoom máximos (Novice friendly)."
    },
    SELECT_STYLE: {
        en: "Select Style",
        es: "Selecciona Estilo",
        pt: "Selecione o Estilo"
    },
    RADAR_DYNAMIC: {
        en: "Dynamic (Centered)",
        es: "Dinámico (Centrado)",
        pt: "Dinâmico (Centrado)"
    },
    RADAR_STATIC: {
        en: "Static (Overview)",
        es: "Estático (Visión General)",
        pt: "Estático (Visão Geral)"
    },
    RADAR_DYNAMIC_SCALE: {
        en: "Dynamic Radar Scale",
        es: "Escala Dinámica del Radar",
        pt: "Escala Dinâmica do Radar"
    },
    RADAR_DYNAMIC_SCALE_DESC: {
        en: "Auto-zoom based on context (New in CS2)",
        es: "Auto-zoom basado en contexto (Nuevo en CS2)",
        pt: "Auto-zoom basado en contexto (Novo no CS2)"
    },

    // Viewmodel Module
    VIEWMODEL_TITLE: {
        en: "Viewmodel",
        es: "Posición del Arma",
        pt: "Posição del Arma"
    },
    VIEWMODEL_DESC: {
        en: "Adjust weapon position and field of view.",
        es: "Ajusta la posición del arma y el campo de visión (FOV).",
        pt: "Ajusta la posição del arma y el campo de visión (FOV)."
    },
    SWITCH_HANDS_BIND: {
        en: "Switch Hands",
        es: "Cambiar de Mano",
        pt: "Mudar de Mão"
    },
    SWITCH_HANDS_BIND_DESC: {
        en: "Key to toggle between left and right hand.",
        es: "Tecla para cambiar entre mano izquierda y derecha.",
        pt: "Tecla para mudar entre mão esquerda e direita."
    },
    LEFT_HAND: {
        en: "Left Hand",
        es: "Zurdo",
        pt: "Esquerda"
    },
    RIGHT_HAND: {
        en: "Right Hand",
        es: "Diestro",
        pt: "Diestro"
    },
    UNBOUND: {
        en: "Unbound",
        es: "Sin asignar",
        pt: "Sin asignar"
    },

    // Practice Extra
    BIND_CLEAR_UTIL: {
        en: "Clear Utility",
        es: "Limpiar Granadas",
        pt: "Limpar Granadas"
    },
    BIND_CLEAR_UTIL_DESC: {
        en: "Removes all smokes, molotovs, and flashes instantly.",
        es: "Elimina todos los humos, molotovs y flashes al instante.",
        pt: "Remove todos os fumos, molotovs e flashes instantaneamente."
    },
    BIND_TOGGLE_IMPACTS: {
        en: "Toggle Impacts",
        es: "Alternar Impactos",
        pt: "Alternar Impactos"
    },
    BIND_TOGGLE_IMPACTS_DESC: {
        en: "Show/Hide bullet impacts on walls.",
        es: "Mostrar/Ocultar impactos de bala en paredes.",
        pt: "Mostrar/Ocultar impactos de bala nas paredes."
    },

    // Binds Module
    RESTORING_DEFAULTS: {
        en: "Restoring Defaults",
        es: "Restaurar Defaults",
        pt: "Restaurar Defaults"
    },
    RESTORING_DEFAULTS_CONFIRM: {
        en: "Are you sure you want to restore default CS2 binds? This will overwrite your current settings.",
        es: "¿Estás seguro de que quieres restaurar los binds por defecto de CS2? Esto sobrescribirá tu configuración actual.",
        pt: "¿Estás seguro de que quieres restaurar los binds por defecto de CS2? Isso sobrescreverá tu configuração actual."
    },
    RESTORE: {
        en: "Restore Default",
        es: "Restaurar por defecto",
        pt: "Restaurar por defecto"
    },
    CLEAR_ALL_BINDS: {
        en: "Clear All Binds",
        es: "Borrar Todos los Binds",
        pt: "Borrar Todos los Binds"
    },
    CLEAR_ALL_BINDS_CONFIRM: {
        en: "Are you sure you want to clear ALL binds? This will leave all keys unassigned, making the game unplayable until you reassign.",
        es: "¿Estás seguro de que quieres borrar TODOS los binds? Esto dejará todas las teclas sin asignar, lo que hará el juego injugable hasta que reasignes.",
        pt: "¿Estás seguro de que quieres borrar TODOS los binds? Esto dejará todas las teclas sin asignar, lo que hará el juego injugable hasta que reasignes."
    },
    CLEAR_ALL: {
        en: "Clear All",
        es: "Borrar Todo",
        pt: "Borrar Todo"
    },
    BUTTONS_AND_BINDS: {
        en: "Buttons & Binds",
        es: "Botones y Binds",
        pt: "Botones y Binds"
    },
    BINDS_BASIC_TITLE: {
        en: "Basic Binds",
        es: "Binds Básicos",
        pt: "Binds Básicos"
    },
    BINDS_BASIC_DESC: {
        en: "Core controls for movement, combat, and essential communication.",
        es: "Controles esenciales para movimiento, combate y comunicación básica.",
        pt: "Controles esenciales para movimiento, combate y comunicação básica."
    },
    BINDS_SPECIAL_TITLE: {
        en: "Special Binds",
        es: "Binds Especiales",
        pt: "Binds Especiales"
    },
    BINDS_SPECIAL_DESC: {
        en: "Advanced scripts like Jumpthrow, grenade binds, and utilities.",
        es: "Scripts avanzados como Jumpthrow, binds de granadas y utilidades.",
        pt: "Scripts avanzados como Jumpthrow, binds de granadas y utilidades."
    },
    ALIAS_SCRIPTING_TITLE: {
        en: "Alias & Scripting",
        es: "Alias & Scripting",
        pt: "Alias & Scripting"
    },
    ALIAS_SCRIPTING_DESC: {
        en: "Create your own complex commands, aliases and advanced scripts.",
        es: "Crea tus propios comandos complejos, alias y scripts avanzados.",
        pt: "Crea tus propios comandos complejos, alias y scripts avanzados."
    },
    BINDS_CUSTOM_TITLE: {
        en: "Custom Buys",
        es: "Custom Buys",
        pt: "Custom Buys"
    },
    BINDS_CUSTOM_DESC: {
        en: "Create your own purchase binders and specialized scripts easily.",
        es: "Crea tus propios binds de compra y scripts especializados fácilmente.",
        pt: "Crea tus propios binds de compra y scripts especializados fácilmente."
    },
    ADD_CUSTOM_BIND: {
        en: "Add New Buy Bind",
        es: "Añadir Nuevo Buy Bind",
        pt: "Adicionar Novo Buy Bind"
    },
    WIZARD_STEP_PRIMARY: {
        en: "Primary Weapon",
        es: "Arma Primaria",
        pt: "Arma Primária"
    },
    WIZARD_STEP_SECONDARY: {
        en: "Secondary Weapon",
        es: "Arma Secundaria",
        pt: "Arma Secundária"
    },
    WIZARD_STEP_GRENADES: {
        en: "Grenades",
        es: "Granadas",
        pt: "Granadas"
    },
    WIZARD_STEP_GEAR: {
        en: "Armor & Kit",
        es: "Chaleco y Kit",
        pt: "Colete e Kit"
    },
    WIZARD_NEXT: {
        en: "Next Step",
        es: "Siguiente Paso",
        pt: "Siguiente Paso"
    },
    WIZARD_BACK: {
        en: "Back",
        es: "Volver",
        pt: "Volver"
    },
    WIZARD_FINISH: {
        en: "Finish",
        es: "Finalizar",
        pt: "Finalizar"
    },
    BIND_NAME_PLACEHOLDER: {
        en: "Bind Name (e.g. Eco Buy)",
        es: "Nombre del Bind (ej. Compra Eco)",
        pt: "Nome do Bind (ex. Compra Eco)"
    },
    SELECT_ITEMS: {
        en: "Select Items",
        es: "Seleccionar Items",
        pt: "Selecionar Items"
    },
    NO_CUSTOM_BINDS: {
        en: "You don't have any custom binds yet. Create your first one!",
        es: "Aún no tienes binds personalizados. ¡Crea el primero!",
        pt: "Você ainda não tem binds personalizados. Crie o primeiro!"
    },
    ITEMS_SELECTED: {
        en: "items selected",
        es: "items seleccionados",
        pt: "items selecionados"
    },
    BASIC_MOVEMENT: {
        en: "Basic Movement",
        es: "Movimiento Básico",
        pt: "Movimiento Básico"
    },
    WEAPONS_ESSENTIALS: {
        en: "Combat Essentials",
        es: "Esenciales de Combate",
        pt: "Esenciales de Combate"
    },
    GRENADES_BINDS: {
        en: "Select Grenade Bind",
        es: "Bind de Seleccionar Granada",
        pt: "Bind de Seleccionar Granada"
    },
    AUTO_BUY_GRENADES: {
        en: "Auto-buy with same key",
        es: "Auto-comprar con la misma tecla",
        pt: "Auto-comprar con la misma tecla"
    },
    AUTO_BUY_GRENADES_DESC: {
        en: "When enabled, pressing the grenade key in buy zone will also purchase that grenade",
        es: "Al activarlo, presionar la tecla de la granada en zona de compra también la comprará",
        pt: "Al activarlo, presionar la tecla de la granada en zona de compra también la comprará"
    },
    PURCHASE_BINDINGS: {
        en: "Purchase Bindings",
        es: "Binds de Compra",
        pt: "Binds de Compra"
    },
    AK47_M4_BUY: {
        en: "AK-47 / M4",
        es: "AK-47 / M4",
        pt: "AK-47 / M4"
    },
    FORCE_SMG_BUY: {
        en: "Force SMG",
        es: "Forzado SMG",
        pt: "Forçado SMG"
    },
    FORCE_RIFLE_BUY: {
        en: "Force Rifle",
        es: "Forzado Rifle",
        pt: "Forçado Rifle"
    },
    FULL_NADES_KIT_BUY: {
        en: "Full Utility",
        es: "Utilidad Completa",
        pt: "Utilidade Completa"
    },
    RECOIL_CROSSHAIR: {
        en: "Follow Recoil",
        es: "Seguir Retroceso",
        pt: "Seguir Retrocesso"
    },
    EQUIPMENT_AUDIO: {
        en: "Equipment & Audio",
        es: "Equipo y Audio",
        pt: "Equipamento e Áudio"
    },
    ZEUS_LABEL: {
        en: "Zeus (Taser)",
        es: "Zeus (Taser)",
        pt: "Zeus (Taser)"
    },
    RADAR_ZOOM_LABEL: {
        en: "Radar Zoom",
        es: "Zoom del Radar",
        pt: "Zoom do Radar"
    },
    CYCLE_VOLUME: {
        en: "Cycle Game Vol",
        es: "Ciclar Vol Juego",
        pt: "Ciclar Vol Jogo"
    },
    CYCLE_VOICE: {
        en: "Cycle Voice Vol",
        es: "Ciclar Vol Voz",
        pt: "Ciclar Vol Voz"
    },
    ADVANCED_TOOLS_LABEL: {
        en: "Advanced Tools",
        es: "Herramientas Avanzadas",
        pt: "Ferramentas Avançadas"
    },
    GRAPHICS_TITLE: {
        en: "Graphics & Performance",
        es: "Gráficos y Rendimiento",
        pt: "Gráficos y Rendimiento"
    },
    RADIO_COMMUNICATION_TITLE: {
        en: "Radio",
        es: "Radio",
        pt: "Rádio"
    },
    CLEAR_SLOT: {
        en: "Clear Slot",
        es: "Limpiar Slot",
        pt: "Limpar Slot"
    },
    GRAPHICS_PREVIEW_TITLE: {
        en: "Graphics",
        es: "Gráficos",
        pt: "Gráficos"
    },
    GRAPHICS_DESC: {
        en: "Optimize your game performance and visuals with specific commands.",
        es: "Optimiza el rendimiento y los visuales de tu juego con comandos específicos.",
        pt: "Optimiza el rendimiento y los visuales de tu juego con comandos específicos."
    },
    VIDEO_TITLE: {
        en: "Video Settings",
        es: "Ajustes de Video",
        pt: "Ajustes de Video"
    },
    VIDEO_DESC: {
        en: "Configure your resolution and display settings for video.txt.",
        es: "Configura tu resolución y ajustes de pantalla para el video.txt.",
        pt: "Configura tu resolução y ajustes de pantalla para el video.txt."
    },
    TRACERS: {
        en: "First Person Tracers",
        es: "Trazadoras en 1ª Persona",
        pt: "Trazadoras en 1ª Persona"
    },
    TRACERS_DESC: {
        en: "Show or hide the bullets tracers from your own weapon.",
        es: "Muestra u oculta las balas trazadoras de tu propia arma.",
        pt: "Muestra u oculta las balas trazadoras de tu propia arma."
    },
    DYNAMIC_LIGHTING: {
        en: "Dynamic Lighting",
        es: "Iluminación Dinámica",
        pt: "Iluminação Dinámica"
    },
    DYNAMIC_LIGHTING_DESC: {
        en: "Enables or disables dynamic light flashes from shots and explosions.",
        es: "Activa o desactiva los destellos de luz dinámica de disparos y explosiones.",
        pt: "Activa o desactiva los destellos de luz dinámica de disparos y explosiones."
    },
    ANIMATED_AVATARS: {
        en: "Animated Avatars",
        es: "Avatares Animados",
        pt: "Avatares Animados"
    },
    ANIMATED_AVATARS_DESC: {
        en: "Enable or disable animated steam avatars in the HUD for better FPS.",
        es: "Activa o desactiva los avatares animados de Steam en el HUD para mejorar FPS.",
        pt: "Activa o desactiva los avatares animados de Steam en el HUD para mejorar FPS."
    },
    LOW_LATENCY: {
        en: "Low Latency Mode",
        es: "Modo Latencia Baja",
        pt: "Modo Latencia Baja"
    },
    LOW_LATENCY_DESC: {
        en: "Reduces input lag by optimizing frame timing.",
        es: "Reduce el retraso de entrada optimizando el tiempo entre frames.",
        pt: "Reduce el retraso de entrada optimizando el tiempo entre frames."
    },
    PRACTICE_TITLE: {
        en: "Practice & Training",
        es: "Práctica y Entrenamiento",
        pt: "Práctica y Entrenamiento"
    },
    PRACTICE_PREVIEW_TITLE: {
        en: "Practice",
        es: "Práctica",
        pt: "Práctica"
    },
    PRACTICE_DESC: {
        en: "Setup a local laboratory to practice granades, movements and more.",
        es: "Crea un laboratorio local para practicar granadas, movimientos y más.",
        pt: "Crea un laboratorio local para practicar granadas, movimientos y más."
    },
    INFINITE_RESOURCES: {
        en: "Infinite Resources",
        es: "Recursos Infinitos",
        pt: "Recursos Infinitos"
    },
    GRENADE_UTILS: {
        en: "Grenade Utilities",
        es: "Utilidades de Granadas",
        pt: "Utilidades de Granadas"
    },
    SERVER_OPTIMIZATION: {
        en: "Practice Server Setup",
        es: "Configuración de Servidor de Práctica",
        pt: "Configuração de Servidor de Práctica"
    },
    BIND_NOCLIP: {
        en: "Noclip Bind (Fly)",
        es: "Bind de Noclip (Volar)",
        pt: "Bind de Noclip (Volar)"
    },
    BIND_RETHROW: {
        en: "Rethrow Last Grenade",
        es: "Relanzar Última Granada",
        pt: "Relanzar Última Granada"
    },
    BIND_BOT_PLACE: {
        en: "Place Bot",
        es: "Colocar Bot",
        pt: "Colocar Bot"
    },
    BIND_BOT_KICK: {
        en: "Kick All Bots",
        es: "Expulsar Bots",
        pt: "Expulsar Bots"
    },
    BIND_TIMESCALE: {
        en: "Timescale Toggle (Fast Forward)",
        es: "Cámara Rápida (Avanzar Tiempo)",
        pt: "Cámara Rápida (Avanzar Tiempo)"
    },
    BIND_RESTART_ROUND: {
        en: "Restart Round",
        es: "Reiniciar Ronda",
        pt: "Reiniciar Ronda"
    },
    SAVE_POSITION: {
        en: "Save Position (Checkpoint)",
        es: "Guardar Posición (Punto de Control)",
        pt: "Guardar Posição (Punto de Control)"
    },
    LOAD_POSITION: {
        en: "Load Position (Teleport)",
        es: "Cargar Posición (Teletransportarse)",
        pt: "Cargar Posição (Teletransportarse)"
    },
    FPS_MAX_LABEL: {
        en: "Max FPS",
        es: "FPS Máximos",
        pt: "FPS Máximos"
    },
    FPS_MAX_DESC: {
        en: "Sets a limit for frames per second. 0 means unlimited.",
        es: "Establece un límite de frames por segundo. 0 significa ilimitado.",
        pt: "Establece un límite de frames por segundo. 0 significa ilimitado."
    },
    RAGDOLLS: {
        en: "Ragdoll Optimization",
        es: "Optimización de Ragdolls",
        pt: "Optimização de Ragdolls"
    },
    RAGDOLLS_DESC: {
        en: "Optimizes death animations of characters.",
        es: "Optimiza las animaciones de muerte de los personajes.",
        pt: "Optimiza las animações de muerte de los personajes."
    },
    RESOLUTION: {
        en: "Resolution",
        es: "Resolución",
        pt: "Resolução"
    },
    REFRESH_RATE: {
        en: "Refresh Rate (Hz)",
        es: "Tasa de Refresco (Hz)",
        pt: "Tasa de Refresco (Hz)"
    },
    FULLSCREEN: {
        en: "Fullscreen",
        es: "Pantalla Completa",
        pt: "Pantalla Completa"
    },
    ASPECT_RATIO: {
        en: "Aspect Ratio",
        es: "Relación de Aspecto",
        pt: "Relação de Aspecto"
    },
    SCRIPTS: {
        en: "Special Binds",
        es: "Binds Especiales",
        pt: "Binds Especiais"
    },
    ADVANCED_TOOLS: {
        en: "Advanced Tools",
        es: "Herramientas Avanzadas",
        pt: "Herramientas Avanzadas"
    },
    EQUIPMENT_AUDIO: {
        en: "Equipment & Audio",
        es: "Equipamiento y Audio",
        pt: "Equipamiento y Audio"
    },
    DROP_BOMB: {
        en: "Drop Bomb",
        es: "Soltar Bomba",
        pt: "Soltar Bomba"
    },
    MOVEMENT: {
        en: "Movement",
        es: "Movimiento",
        pt: "Movimiento"
    },
    MOVEMENT_INTERACTIONS: {
        en: "Movement & Interactions",
        es: "Movimiento & Interacciones",
        pt: "Movimiento & Interacções"
    },
    CYCLE_VOLUME: {
        en: "Cycle Volume",
        es: "Ciclar Volumen",
        pt: "Ciclar Volumen"
    },
    CYCLE_VOLUME_DESC: {
        en: "Cycles game volume between multiple levels (e.g., Mute, 50%, 100%) with a single key.",
        es: "Alterna el volumen del juego entre varios niveles (ej: Mute, 50%, 100%) con una sola tecla.",
        pt: "Alterna o volume do jogo entre vários níveis (ex: Mudo, 50%, 100%) com uma única tecla."
    },
    CYCLE_VOICE: {
        en: "Cycle Voice",
        es: "Ciclar Voz",
        pt: "Ciclar Voz"
    },
    CYCLE_VOICE_DESC: {
        en: "Cycles voice chat volume between multiple levels (e.g., Mute, 50%, 100%) with a single key.",
        es: "Alterna el volumen del chat de voz entre varios niveles (ej: Mute, 50%, 100%) con una sola tecla.",
        pt: "Alterna o volume do bate-papo de voz entre vários níveis (ex: Mudo, 50%, 100%) com uma única tecla."
    },
    COMBAT: {
        en: "Combat",
        es: "Combate",
        pt: "Combate"
    },
    COMBAT_WEAPONS: {
        en: "Combat & Weapons",
        es: "Combate & Armas",
        pt: "Combate & Armas"
    },
    COMMUNICATION: {
        en: "Speak",
        es: "Charla",
        pt: "Charla"
    },
    OTHERS: {
        en: "Others",
        es: "Otros",
        pt: "Otros"
    },
    BASIC: {
        en: "Basic",
        es: "Básicos",
        pt: "Básicos"
    },
    FORWARD: {
        en: "Forward",
        es: "Adelante",
        pt: "Adelante"
    },
    BACKWARD: {
        en: "Backward",
        es: "Atrás",
        pt: "Atrás"
    },
    LEFT: {
        en: "Left",
        es: "Izquierda",
        pt: "Izquierda"
    },
    RIGHT: {
        en: "Right",
        es: "Derecha",
        pt: "Derecha"
    },
    WALK: {
        en: "Walk",
        es: "Caminar",
        pt: "Caminar"
    },
    DUCK: {
        en: "Duck",
        es: "Agacharse",
        pt: "Agacharse"
    },
    JUMP: {
        en: "Jump",
        es: "Saltar",
        pt: "Saltar"
    },
    SPECIALS: {
        en: "Especiales",
        es: "Especiales",
        pt: "Especiales"
    },
    MWHEEL_JUMP_DESC: {
        en: "Jump with the mouse wheel (Bunnyhop)",
        es: "Saltar con la rueda del ratón (Bunnyhop)",
        pt: "Saltar con la rueda del ratón (Bunnyhop)"
    },
    DISABLED: {
        en: "Disabled",
        es: "Desactivado",
        pt: "Desactivado"
    },
    WHEEL_UP: {
        en: "Wheel Up",
        es: "Rueda Arriba",
        pt: "Rueda Arriba"
    },
    WHEEL_DOWN: {
        en: "Wheel Down",
        es: "Rueda Abajo",
        pt: "Rueda Abajo"
    },
    BOTH: {
        en: "Both",
        es: "Ambas",
        pt: "Ambas"
    },
    WEAPONS: {
        en: "Weapons",
        es: "Armas",
        pt: "Armas"
    },
    ATTACK: {
        en: "Attack",
        es: "Disparo",
        pt: "Disparo"
    },
    ATTACK2: {
        en: "Aim (Zoom)",
        es: "Mira (Zoom)"
    },
    RELOAD: {
        en: "Reload",
        es: "Recargar",
        pt: "Recargar"
    },
    USE: {
        en: "Use",
        es: "Usar",
        pt: "Usar"
    },
    DROP_WEAPON: {
        en: "Drop Weapon",
        es: "Soltar Arma",
        pt: "Soltar Arma"
    },
    KEY_SHOW_LOADOUT: {
        en: "Toggle Loadout",
        es: "Ver Equipamiento",
        pt: "Ver Equipamiento"
    },
    KEY_TEAM_MENU: {
        en: "Team Menu",
        es: "Menú de Equipo",
        pt: "Menú de Equipo"
    },
    KEY_TEAM_EQUIP: {
        en: "Show Team Equipment",
        es: "Mostrar Equipo de Compañeros",
        pt: "Mostrar Equipo de Compañeros"
    },
    KEY_RADIO: {
        en: "Radio Command",
        es: "Comando de Radio",
        pt: "Comando de Radio"
    },
    KEY_RADIO2: {
        en: "Radio Command 2",
        es: "Comando de Radio 2"
    },
    KEY_RADIO3: {
        en: "Radio Command 3",
        es: "Comando de Radio 3"
    },
    KEY_RADIAL_RADIO: {
        en: "Radial Radio Menu",
        es: "Menú Radial de Radio",
        pt: "Menú Radial de Radio"
    },
    KEY_RADIAL_RADIO2: {
        en: "Radial Radio Menu 2",
        es: "Menú Radial de Radio 2"
    },
    KEY_SCORE: {
        en: "Scoreboard",
        es: "Puntuación",
        pt: "Puntuação"
    },
    KEY_SCREENSHOT: {
        en: "Take Screenshot",
        es: "Captura de Pantalla",
        pt: "Captura de Pantalla"
    },
    KEY_QUIT_PROMPT: {
        en: "Quit Prompt",
        es: "Confirmación de Salida",
        pt: "Confirmação de Salida"
    },
    KEY_SELL_BACK_ALL: {
        en: "Refund All",
        es: "Reembolsar Todo",
        pt: "Reembolsar Todo"
    },
    KEY_INV_NEXT: {
        en: "Next Weapon",
        es: "Siguiente Arma",
        pt: "Siguiente Arma"
    },
    KEY_INV_PREV: {
        en: "Previous Weapon",
        es: "Arma Anterior",
        pt: "Arma Anterior"
    },
    KEY_CANCEL_SELECT: {
        en: "Cancel Select/Menu",
        es: "Cancelar/Cerrar Menú",
        pt: "Cancelar/Cerrar Menú"
    },
    INSPECT: {
        en: "Inspect",
        es: "Inspeccionar",
        pt: "Inspeccionar"
    },
    LAST_WEAPON: {
        en: "Last Weapon",
        es: "Última Arma",
        pt: "Última Arma"
    },
    DROP_BOMB: {
        en: "Drop Bomb",
        es: "Soltar Bomba",
        pt: "Soltar Bomba"
    },
    WEAPON_SLOTS: {
        en: "Weapon Slots",
        es: "Slots de Armas",
        pt: "Slots de Armas"
    },
    SLOT1_PRIMARY: {
        en: "Slot 1 - Primary",
        es: "Slot 1 - Primaria"
    },
    SLOT2_SECONDARY: {
        en: "Slot 2 - Secondary",
        es: "Slot 2 - Secundaria"
    },
    SLOT3_KNIFE: {
        en: "Slot 3 - Knife",
        es: "Slot 3 - Cuchillo"
    },
    SLOT4_GRENADES: {
        en: "Slot 4 - Grenades",
        es: "Slot 4 - Granadas"
    },
    SLOT5_BOMB: {
        en: "Slot 5 - Bomb",
        es: "Slot 5 - Bomba"
    },
    BUY_MENU: {
        en: "Buy Menu",
        es: "Menú Compra",
        pt: "Menú Compra"
    },
    AUTO_BUY: {
        en: "Buy this grenade using same key",
        es: "Comprar esta granada usando la misma tecla",
        pt: "Comprar esta granada usando a mesma tecla"
    },
    RE_BUY: {
        en: "Re-Buy",
        es: "Re-Compra",
        pt: "Re-Compra"
    },
    AUTO_BUY_DESC: {
        en: "Auto-buy weapon and equipment based on available money.",
        es: "Compra automática de armas y equipo según dinero disponible.",
        pt: "Compra automática de armas y equipo según dinero disponible."
    },
    RE_BUY_DESC: {
        en: "Re-buy everything you bought in the previous round.",
        es: "Vuelve a comprar todo lo de la ronda anterior.",
        pt: "Vuelve a comprar todo lo de la ronda anterior."
    },
    DROP_WEAPON_DESC: {
        en: "Drop your current held weapon to a teammate.",
        es: "Suelta el arma que tienes en la mano para un compañero.",
        pt: "Suelta el arma que tienes en la mano para un compañero."
    },
    GRENADES: {
        en: "Grenades",
        es: "Granadas",
        pt: "Granadas"
    },
    BUYS: {
        en: "Buys",
        es: "Compras",
        pt: "Compras"
    },
    BUY_FULL_AK: {
        en: "Full Buy (AK-47)",
        es: "Compra Completa (AK-47)",
        pt: "Compra Completa (AK-47)"
    },
    BUY_FULL_AK_DESC: {
        en: "Buys AK-47, Armor + Helmet, and Defuse Kit.",
        es: "Compra AK-47, Chaleco + Casco y Kit de Desactivación.",
        pt: "Compra AK-47, Chaleco + Casco y Kit de Desactivação."
    },
    BUY_FULL_M4: {
        en: "Full Buy (M4)",
        es: "Compra Completa (M4)"
    },
    BUY_FULL_M4_DESC: {
        en: "Buys M4, Armor + Helmet, and Defuse Kit.",
        es: "Compra M4, Chaleco + Casco y Kit de Desactivación."
    },
    BUY_FULL_AWP: {
        en: "Full Buy (AWP)",
        es: "Compra Completa (AWP)",
        pt: "Compra Completa (AWP)"
    },
    BUY_FULL_AWP_DESC: {
        en: "Buys AWP, Armor + Helmet, and Defuse Kit.",
        es: "Compra AWP, Chaleco + Casco y Kit de Desactivación.",
        pt: "Compra AWP, Chaleco + Casco y Kit de Desactivação."
    },
    BUY_GRENADES_EFFICIENT: {
        en: "Grenades (Efficient)",
        es: "Granadas (Eficiente)",
        pt: "Granadas (Eficiente)"
    },
    BUY_GRENADES_EFFICIENT_DESC: {
        en: "Buys Flash, Smoke, HE, and Molotov/Incendiary.",
        es: "Compra Flash, Humo, HE y Molotov/Incendiaria.",
        pt: "Compra Flash, Humo, HE y Molotov/Incendiaria."
    },
    BUY_ECO_DEAGLE: {
        en: "Eco (Deagle)",
        es: "Eco (Deagle)",
        pt: "Eco (Deagle)"
    },
    BUY_ECO_DEAGLE_DESC: {
        en: "Buys Desert Eagle and Body Armor.",
        es: "Compra Desert Eagle y Chaleco.",
        pt: "Compra Desert Eagle y Chaleco."
    },
    BUY_FORCE_SMG: {
        en: "Force Buy (SMG)",
        es: "Compra Forzada (SMG)",
        pt: "Compra Forzada (SMG)"
    },
    BUY_FORCE_SMG_DESC: {
        en: "Buys MAC-10/MP9 and Armor + Helmet.",
        es: "Compra MAC-10/MP9 y Chaleco + Casco.",
        pt: "Compra MAC-10/MP9 y Chaleco + Casco."
    },
    BUY_FORCE_RIFLE: {
        en: "Force Buy (Galil/Famas)",
        es: "Compra Forzada (Galil/Famas)",
        pt: "Compra Forzada (Galil/Famas)"
    },
    BUY_FORCE_RIFLE_DESC: {
        en: "Buys Galil AR/Famas and Armor + Helmet.",
        es: "Compra Galil AR/Famas y Chaleco + Casco.",
        pt: "Compra Galil AR/Famas y Chaleco + Casco."
    },
    BUY_SCOUT: {
        en: "Scout (SSG 08)",
        es: "Scout (SSG 08)",
        pt: "Scout (SSG 08)"
    },
    BUY_SCOUT_DESC: {
        en: "Buys SSG 08 and Armor + Helmet.",
        es: "Compra SSG 08 y Chaleco + Casco.",
        pt: "Compra SSG 08 y Chaleco + Casco."
    },
    BUY_XM1014: {
        en: "Auto Shotgun (XM1014)",
        es: "Escopeta Auto (XM1014)"
    },
    BUY_XM1014_DESC: {
        en: "Buys XM1014 and Armor + Helmet.",
        es: "Compra XM1014 y Chaleco + Casco."
    },
    BUY_P250: {
        en: "Pistol Upgrade (P250)",
        es: "Mejora Pistola (P250)"
    },
    BUY_P250_DESC: {
        en: "Buys P250 and Body Armor.",
        es: "Compra P250 y Chaleco."
    },
    FLASHBANG: {
        en: "Flashbang",
        es: "Granada Cegadora",
        pt: "Granada Cegadora"
    },
    SMOKE: {
        en: "Smoke",
        es: "Humo",
        pt: "Humo"
    },
    HE_GRENADE: {
        en: "HE Grenade",
        es: "Granada Explosiva",
        pt: "Granada Explosiva"
    },
    MOLOTOV: {
        en: "Molotov",
        es: "Molotov",
        pt: "Molotov"
    },
    DECOY: {
        en: "Decoy",
        es: "Decoy",
        pt: "Decoy"
    },
    UTILITIES: {
        en: "Utilities",
        es: "Utilidades",
        pt: "Utilidades"
    },
    ZEUS_TAZER: {
        en: "Zeus / Tazer",
        es: "Zeus / Tazer",
        pt: "Zeus / Tazer"
    },
    HEALTH_SHOT: {
        en: "Healthshot",
        es: "Jeringa de Salud",
        pt: "Jeringa de Salud"
    },
    JUMP_THROW_DESC: {
        en: "Jump and throw perfect smoke",
        es: "Saltar y lanzar humo perfecto",
        pt: "Saltar y lanzar humo perfecto"
    },
    FOLLOW_RECOIL_DESC_KB: {
        en: "Dynamic crosshair follows spray",
        es: "Mira dinámica que sigue el spray",
        pt: "Mira dinámica que sigue el spray"
    },
    MICROPHONE: {
        en: "Microphone",
        es: "Micrófono",
        pt: "Micrófono"
    },
    GLOBAL_CHAT: {
        en: "Global Chat",
        es: "Chat Global",
        pt: "Chat Global"
    },
    TEAM_CHAT: {
        en: "Team Chat",
        es: "Chat Equipo",
        pt: "Chat Equipo"
    },
    PING_SIGNAL: {
        en: "Ping / Signal",
        es: "Ping / Señalar",
        pt: "Ping / Señalar"
    },
    RADIO: {
        en: "Radio",
        es: "Radio",
        pt: "Radio"
    },
    RADIO_MENU_1: {
        en: "Radio Menu 1",
        es: "Menú Radio 1"
    },
    RADIO_MENU_2: {
        en: "Radio Menu 2",
        es: "Menú Radio 2"
    },
    RADIO_MENU_3: {
        en: "Radio Menu 3",
        es: "Menú Radio 3"
    },
    PING_SIGNAL_DESC: {
        en: "Mark a location or enemy for your team.",
        es: "Marca una posición o enemigo para tu equipo.",
        pt: "Marca una posição o enemigo para tu equipo."
    },
    RADIO_MENU_DESC: {
        en: "Open radio commands menu to communicate with the team.",
        es: "Abre el menú de comandos de radio para comunicarte.",
        pt: "Abre el menú de comandos de radio para comunicarte."
    },
    TEAM_EQUIP_ID_DESC: {
        en: "Toggle permanent visibility of equipment over allies' heads.",
        es: "Activa la visibilidad permanente del equipo sobre los aliados.",
        pt: "Activa la visibilidad permanente del equipo sobre los aliados."
    },
    MUTE_ALL: {
        en: "Mute All Voice",
        es: "Silenciar Voz Global",
        pt: "Silenciar Voz Global"
    },
    MUTE_ALL_DESC: {
        en: "Mute all (Clutch bind)",
        es: "Silenciar a todos (Clutch bind)",
        pt: "Silenciar a todos (Clutch bind)"
    },
    UI_VARIOUS: {
        en: "UI & Various",
        es: "UI y Varios",
        pt: "UI y Varios"
    },
    SCOREBOARD: {
        en: "Scoreboard",
        es: "Tabla de Puntos",
        pt: "Tabla de Puntos"
    },
    CONSOLE: {
        en: "Console",
        es: "Consola",
        pt: "Consola"
    },
    GRAFFITI_SPRAY: {
        en: "Graffiti / Spray",
        es: "Graffiti / Spray",
        pt: "Graffiti / Spray"
    },
    TEAM_EQUIP_ID: {
        en: "Show Team (+ID)",
        es: "Ver Equipo (+ID)",
        pt: "Ver Equipo (+ID)"
    },
    OPTIONS: {
        en: "Options",
        es: "Opciones",
        pt: "Opções"
    },
    CLEAR_DECALS_DESC: {
        en: "Clear blood/bullets when walking (Shift)",
        es: "Borrar sangre/balas al caminar (Shift)",
        pt: "Borrar sangre/balas al caminar (Shift)"
    },
    PRO_PLAYER_PRESETS: {
        en: "Pro Players Presets (Real Binds)",
        es: "Presets Pro Players (Binds Reales)",
        pt: "Presets Pro Players (Binds Reales)"
    },
    APPLY_PRESET_TITLE: {
        en: "Apply Preset for",
        es: "Aplicar Preset de",
        pt: "Aplicar Preset de"
    },
    APPLY_PRESET_CONFIRM: {
        en: "Do you want to apply the button configuration of {player}? This will replace your current binds.",
        es: "¿Quieres aplicar la confiruación de botones de {player}? Esto reemplazará tus binds actuales.",
        pt: "¿Quieres aplicar la confiruação de botones de {player}? Esto reemplazará tus binds actuales."
    },
    APPLY: {
        en: "Apply",
        es: "Aplicar",
        pt: "Aplicar"
    },

    // Viewmodel Module Details
    WEAPON: {
        en: "Weapon",
        es: "Arma",
        pt: "Arma"
    },
    STYLES: {
        en: "Styles",
        es: "Estilos",
        pt: "Estilos"
    },
    OFFSET_X_DESC: {
        en: "Moves weapon left/right",
        es: "Mueve el arma a la izquierda/derecha",
        pt: "Mueve el arma a la izquierda/derecha"
    },
    OFFSET_Y_DESC: {
        en: "Moves weapon forward/back",
        es: "Mueve el arma hacia adelante/atrás",
        pt: "Mueve el arma hacia adelante/atrás"
    },
    OFFSET_Z_DESC: {
        en: "Moves weapon up/down",
        es: "Mueve el arma hacia arriba/abajo",
        pt: "Mueve el arma hacia arriba/abajo"
    },
    FOV_DESC: {
        en: "Field of view",
        es: "Campo de visión",
        pt: "Campo de visión"
    },
    SWITCH_HANDS_BIND: {
        en: "Switch Hands",
        es: "Cambiar de Mano",
        pt: "Mudar de Mão"
    },
    SWITCH_HANDS_DESC_KB: {
        en: "Switch weapon hand (Left/Right)",
        es: "Cambia el arma de mano (Izquierda/Derecha)",
        pt: "Cambia el arma de mano (Izquierda/Derecha)"
    },
    DESKTOP: { en: "Desktop", es: "Escritorio" },
    COUCH: { en: "Couch", es: "Sofá" },
    CLASSIC: { en: "Classic", es: "Clásico" },
    DOOM: { en: "Doom", es: "Doom" },
    QUAKE: { en: "Quake", es: "Quake" },
    GANGSTER: { en: "Gangster", es: "Gangster" },
    MINIMAL: { en: "Minimal", es: "Mínimo" },

    // Common / UI
    SAVING: {
        en: "SAVING...",
        es: "GUARDANDO...",
        pt: "GUARDANDO..."
    },
    PREMIUM_MEMBER: {
        en: "Premium Member",
        es: "Miembro Premium",
        pt: "Miembro Premium"
    },
    STANDARD_USER: {
        en: "Standard User",
        es: "Usuario Estándar",
        pt: "Usuario Estándar"
    },
    LOGOUT: {
        en: "Logout",
        es: "Cerrar Sesión",
        pt: "Cerrar Sesión"
    },
    VIEWMODEL_GEOMETRY: {
        en: "Viewmodel Geometry",
        es: "Geometría del Viewmodel",
        pt: "Geometría del Viewmodel"
    },
    GET_PREMIUM_PRICE: {
        en: "Get Premium $1",
        es: "Obtener Premium $1",
        pt: "Obtener Premium $1"
    },
    JOIN_THE_STRIKE: {
        en: "Join the Strike",
        es: "Únete al Strike",
        pt: "Únete al Strike"
    },
    DELETE: {
        en: "Delete",
        es: "Eliminar",
        pt: "Eliminar"
    },
    CANCEL: {
        en: "Cancel",
        es: "Cancelar",
        pt: "Cancelar"
    },
    PREMIUM_REQUIRED_CLOUD: {
        en: "You need a PREMIUM account to save configurations in the cloud.",
        es: "Necesitas una cuenta PREMIUM para guardar configuraciones en la nube.",
        pt: "Necesitas una cuenta PREMIUM para guardar configurações en la nube."
    },
    EFFECTIVE_DPI: {
        en: "Effective DPI",
        es: "DPI Efectivo",
        pt: "DPI Efectivo"
    },
    ZOOM_RATIO: {
        en: "Zoom",
        es: "Zoom",
        pt: "Zoom"
    },
    BASE_DPI: {
        en: "DPI Base",
        es: "DPI Base",
        pt: "DPI Base"
    },
    RADAR_SCALE: {
        en: "Radar",
        es: "Radar",
        pt: "Radar"
    },
    RADAR_SIZE: {
        en: "Size",
        es: "Tamaño",
        pt: "Tamaño"
    },
    HUD_SCALE: {
        en: "HUD",
        es: "HUD",
        pt: "HUD"
    },
    ROTATE: {
        en: "Rotate",
        es: "Rotar",
        pt: "Rotar"
    },
    FIXED: {
        en: "Fixed",
        es: "Fijo",
        pt: "Fijo"
    },
    OPERATIONAL: {
        en: "OPERATIONAL",
        es: "OPERATIVO",
        pt: "OPERATIVO"
    },
    OFFLINE: {
        en: "OFFLINE",
        es: "DESCONECTADO",
        pt: "DESCONECTADO"
    },
    PROTOCOLS_BINDS: {
        en: "Protocols & Binds",
        es: "Protocolos y Binds",
        pt: "Protocolos y Binds"
    },
    MWHEEL_JUMP: {
        en: "Mwheel Jump",
        es: "Salto con Rueda",
        pt: "Salto con Rueda"
    },
    // HUD Colors
    HUD_COLOR_DEFAULT: { en: "Default", es: "Predeterminado" },
    HUD_COLOR_SOFT_WHITE: { en: "Soft White", es: "Blanco Suave" },
    HUD_COLOR_BRIGHT_WHITE: { en: "Bright White", es: "Blanco Brillante" },
    HUD_COLOR_LIGHT_BLUE: { en: "Light Blue", es: "Azul Claro" },
    HUD_COLOR_DARK_BLUE: { en: "Dark Blue", es: "Azul Oscuro" },
    HUD_COLOR_PURPLE: { en: "Purple", es: "Morado" },
    HUD_COLOR_RED: { en: "Red", es: "Rojo" },
    HUD_COLOR_ORANGE: { en: "Orange", es: "Naranja" },
    HUD_COLOR_YELLOW: { en: "Yellow", es: "Amarillo" },
    HUD_COLOR_GREEN: { en: "Green", es: "Verde" },
    HUD_COLOR_CYAN: { en: "Cyan", es: "Cian" },
    HUD_COLOR_PINK: { en: "Pink", es: "Rosa" },
    HUD_COLOR_CELESTE: { en: "Celeste", es: "Celeste" },
    HUD_COLOR_BEIGE: { en: "Beige", es: "Beige" },
    ENTER_CONFIG_NAME: {
        en: "Enter Config Name:",
        es: "Nombre de la Configuración:",
        pt: "Nombre de la Configuração:"
    },
    RIGHT_HAND: {
        en: "Right",
        es: "Derecha",
        pt: "Derecha"
    },
    LEFT_HAND: {
        en: "Left",
        es: "Izquierda",
        pt: "Izquierda"
    },
    JOIN_THE_STRIKE: {
        en: "Join the Strike",
        es: "Únete al Strike",
        pt: "Únete al Strike"
    },
    GET_PREMIUM_PRICE: {
        en: "Get Premium - $2.99",
        es: "Obtener Premium - $2.99",
        pt: "Obtener Premium - $2.99"
    },
    VIEWMODEL_GEOMETRY: {
        en: "Viewmodel Geometry",
        es: "Geometría del Viewmodel",
        pt: "Geometría del Viewmodel"
    },
    LOCKED_CONFIG_TITLE: {
        en: "Locked Configuration",
        es: "Configuración Bloqueada",
        pt: "Configuração Bloqueada"
    },
    LOCKED_CONFIG_MESSAGE: {
        en: "Do you want to duplicate this configuration?",
        es: "Duplicar esta configuración?",
        pt: "Duplicar esta configuração?"
    },
    NEW_COPY_NAME: {
        en: "New copy name",
        es: "Nombre de la nueva copia",
        pt: "Nombre de la nueva copia"
    },
    LOCK: {
        en: "Lock",
        es: "Bloquear",
        pt: "Bloquear"
    },
    UNLOCK: {
        en: "Unlock",
        es: "Desbloquear",
        pt: "Desbloquear"
    },
    SELECT_ALL: {
        en: "Select All",
        es: "Seleccionar Todo",
        pt: "Selecionar Todo"
    },
    MY_CONFIGURATIONS: {
        en: "MIS CONFIGURACIONES",
        es: "MIS CONFIGURACIONES",
        pt: "MIS CONFIGURACIONES"
    },
    SELECTED_COUNT: {
        en: "{count} Selected",
        es: "{count} Seleccionados",
        pt: "{count} Seleccionados"
    },
    DELETE_BATCH: {
        en: "Delete Batch",
        es: "Borrar Lote",
        pt: "Borrar Lote"
    },

    // Graphics Module Additions
    RECOMMENDED: {
        en: "Recommended",
        es: "Recomendado",
        pt: "Recomendado"
    },
    REFRESH_RATE_DESC_HELP: {
        en: "Monitor refresh rate (Hz)",
        es: "Hercios de tu monitor",
        pt: "Hercios de tu monitor"
    },
    UNLIMITED: {
        en: "Unlimited",
        es: "Ilimitado",
        pt: "Ilimitado"
    },
    FULLSCREEN_DESC_HELP: {
        en: "Use fullscreen mode for minimum latency.",
        es: "Usa modo pantalla completa para menor latencia.",
        pt: "Usa modo pantalla completa para menor latencia."
    },

    // Practice Module Additions
    PRAC_TIP: {
        en: "You have a command called 'prac' that, when typed in the console or assigned to a bind, loads practice mode using the options configured here.",
        es: "Tienes creado un comando llamado 'prac' que al escribirlo en la consola o al asignarle un bind hace que cargue el modo práctica usando las opciones aquí configuradas.",
        pt: "Você tem um comando chamado 'prac' que, ao digitá-lo no console ou ao atribuí-lo a um bind, carrega o modo prática usando as opções configuradas aqui."
    },
    CHEAT_MODE_LABEL: {
        en: "Cheat Mode",
        es: "Modo Trucos",
        pt: "Modo Trucos"
    },
    INFINITE_RESOURCES_DESC_HELP: {
        en: "Gives you unlimited ammo, maximum money (64k), allows buying anywhere on the map, and removes the buy time limit completely.",
        es: "Te da munición infinita, dinero máximo (64k), permite comprar en cualquier parte del mapa y elimina el límite de tiempo de compra por completo.",
        pt: "Te da munição infinita, dinero máximo (64k), permite comprar en cualquier parte del mapa y elimina el límite de tiempo de compra por completo."
    },
    GRENADE_UTILS_DESC_HELP: {
        en: "Shows where grenades hit, adds a small camera preview of the landing spot, and draws trails to easily track grenade paths.",
        es: "Muestra dónde impactan las granadas, añade una pequeña cámara para ver dónde caen y dibuja estelas para seguir su trayectoria fácilmente.",
        pt: "Muestra dónde impactan las granadas, añade una pequeña cámara para ver dónde caen y dibuja estelas para seguir su trayectoria fácilmente."
    },
    AUTO_SETUP: {
        en: "Infinite Time",
        es: "Tiempo Infinito",
        pt: "Tiempo Infinito"
    },
    AUTO_SETUP_DESC_HELP: {
        en: "Sets round time to 60 minutes, removes freeze time at start, disables team limits, and ends warmup instantly so you can start practicing immediately.",
        es: "Pone el tiempo de ronda en 60 minutos, quita el tiempo de espera al inicio, elimina límites de equipo y termina el calentamiento para empezar ya.",
        pt: "Pone el tiempo de ronda en 60 minutos, quita el tiempo de espera al inicio, elimina límites de equipo y termina el calentamiento para empezar ya."
    },
    BINDS_PRACTICE_TITLE: {
        en: "Practice Binds",
        es: "Binds de Práctica",
        pt: "Binds de Práctica"
    },
    NOCLIP_DESC: {
        en: "Fly through walls and move anywhere",
        es: "Vuela por el mapa y atraviesa paredes",
        pt: "Vuela por el mapa y atraviesa paredes"
    },
    NOCLIP_HELP: {
        en: "Allows you to fly freely through the map. Essential for exploring and moving quickly between grenade positions.",
        es: "Te permite volar libremente por el mapa. Es esencial para explorar y moverte rápido entre posiciones de granadas.",
        pt: "Te permite volar libremente por el mapa. Es esencial para explorar y moverte rápido entre posições de granadas."
    },
    RETHROW_DESC: {
        en: "Repeat your last grenade throw",
        es: "Repite tu último lanzamiento",
        pt: "Repite tu último lanzamiento"
    },
    RETHROW_HELP: {
        en: "Automatically throws the last grenade you used again with the exact same power and direction. Ideal for checking if a smoke lands correctly.",
        es: "Vuelve a lanzar automáticamente tu última granada con la misma fuerza y dirección. Ideal para ver si un smoke cae bien desde el punto de impacto.",
        pt: "Vuelve a lanzar automáticamente tu última granada con la misma fuerza y direcção. Ideal para ver si un smoke cae bien desde el punto de impacto."
    },
    TIMESCALE_DESC: {
        en: "Fast forward time (x10 speed)",
        es: "Avanza el tiempo rápido (x10)",
        pt: "Avanza el tiempo rápido (x10)"
    },
    TIMESCALE_HELP: {
        en: "Speeds up the game clock. Use this to skip the wait for smokes to clear or to see where a long grenade lands quickly.",
        es: "Acelera el reloj del juego. Úsalo para no esperar a que se despejen los smokes o ver rápido dónde cae una granada lejana.",
        pt: "Acelera el reloj del juego. Úsalo para no esperar a que se despejen los smokes o ver rápido dónde cae una granada lejana."
    },
    RESTART_ROUND_DESC: {
        en: "Reset everything instantly",
        es: "Reinicia todo al instante",
        pt: "Reinicia todo al instante"
    },
    RESTART_ROUND_HELP: {
        en: "Clears all grenades, resets player positions, and starts a fresh round immediately.",
        es: "Limpia todas las granadas, resetea posiciones y comienza una ronda nueva de inmediato.",
        pt: "Limpia todas las granadas, resetea posições y comienza una ronda nueva de inmediato."
    },
    CHECKPOINTS_BOTS: {
        en: "Checkpoints & Bots",
        es: "Checkpoints y Bots",
        pt: "Checkpoints y Bots"
    },
    SAVE_POS_DESC: {
        en: "Save your current coordinates",
        es: "Guarda tus coordenadas",
        pt: "Guarda tus coordenadas"
    },
    LOAD_POS_DESC: {
        en: "Teleport back to saved position",
        es: "Vuelve al punto guardado",
        pt: "Vuelve al punto guardado"
    },
    BOT_PLACE_DESC: {
        en: "Place a bot where you are looking",
        es: "Coloca un bot donde miras",
        pt: "Coloca un bot donde miras"
    },
    ADD_BOT_T: {
        en: "Add Bot T",
        es: "Añadir Bot T",
        pt: "Añadir Bot T"
    },
    ADD_BOT_CT: {
        en: "Add Bot CT",
        es: "Añadir Bot CT",
        pt: "Añadir Bot CT"
    },
    BOT_KICK_HELP: {
        en: "Removes all bots currently on the server.",
        es: "Elimina a todos los bots actuales del servidor.",
        pt: "Elimina a todos los bots actuales del servidor."
    },
    SAVE_POS_HELP: {
        en: "Saves your current GPS coordinates. You can return here later with the 'Load Position' key.",
        es: "Guarda tus coordenadas GPS actuales. Podrás volver a este punto exacto después con la tecla de 'Cargar Posición'.",
        pt: "Guarda tus coordenadas GPS actuales. Podrás volver a este punto exacto después con la tecla de 'Cargar Posição'."
    },
    LOAD_POS_HELP: {
        en: "Instantly teleports you back to the last saved location. Perfect for practicing lineups multiple times.",
        es: "Te teletransporta instantáneamente al último punto que guardaste. Perfecto para repetir lineups muchas veces sin caminar.",
        pt: "Te teletransporta instantáneamente al último punto que guardaste. Perfecto para repetir lineups muchas veces sin caminar."
    },
    BOT_PLACE_HELP: {
        en: "Spawns a static bot exactly where your crosshair is pointing. Useful for testing angles and wallbangs.",
        es: "Crea un bot estático exactamente donde apunta tu mira. Útil para testear ángulos y wallbangs.",
        pt: "Crea un bot estático exactamente donde apunta tu mira. Útil para testear ángulos y wallbangs."
    },
    BOT_FREEZE: {
        en: "Freeze Bots",
        es: "Congelar Bots",
        pt: "Congelar Bots"
    },
    BOT_FREEZE_DESC_HELP: {
        en: "Prevents bots from moving (bot_stop 1)",
        es: "Evita que los bots se muevan (bot_stop 1)",
        pt: "Evita que los bots se muevan (bot_stop 1)"
    },
    AUTO_HEAL: {
        en: "Auto-Heal",
        es: "Auto-Curación",
        pt: "Auto-Curação"
    },
    AUTO_HEAL_DESC_HELP: {
        en: "Regenerates health automatically (sv_regeneration_force_on 1)",
        es: "Regenera vida automáticamente (sv_regeneration_force_on 1)",
        pt: "Regenera vida automáticamente (sv_regeneration_force_on 1)"
    },
    RADAR_PRACTICE: {
        en: "Radar Hack",
        es: "Radar Hack",
        pt: "Radar Hack"
    },
    RADAR_PRACTICE_DESC_HELP: {
        en: "Shows all players on radar (mp_radar_showall 1)",
        es: "Muestra a todos en el radar (mp_radar_showall 1)",
        pt: "Muestra a todos en el radar (mp_radar_showall 1)"
    },
    WALLBANG_DATA: {
        en: "Wallbang Info",
        es: "Info Wallbang",
        pt: "Info Wallbang"
    },
    WALLBANG_DATA_DESC_HELP: {
        en: "Show penetration damage and depth (sv_showimpacts_penetration 1)",
        es: "Muestra daño de penetración y profundidad (sv_showimpacts_penetration 1)",
        pt: "Muestra daño de penetração y profundidad (sv_showimpacts_penetration 1)"
    },
    AUTO_BHOP: {
        en: "Auto-Bhop",
        es: "Auto-Bhop",
        pt: "Auto-Bhop"
    },
    AUTO_BHOP_DESC_HELP: {
        en: "Enable automatic bunnyhopping by holding space",
        es: "Habilita bunnyhop automático manteniendo espacio",
        pt: "Habilita bunnyhop automático manteniendo espacio"
    },
    BIND_PRAC: {
        en: "PRACTICE BIND",
        es: "BIND DE PRACTICA",
        pt: "BIND DE PRACTICA"
    },
    NOT_ASSIGNED: {
        en: "NOT ASSIGNED",
        es: "SIN ASIGNAR",
        pt: "SIN ASIGNAR"
    },
    CREATE_FIRST_CONFIG: {
        en: "Create First Config",
        es: "Crear Primera Config",
        pt: "Crear Primera Config"
    },
    SYSTEM_BADGE: {
        en: "System",
        es: "Sistema",
        pt: "Sistema"
    },
    RENAME: {
        en: "Rename",
        es: "Renombrar",
        pt: "Renombrar"
    },
    DUPLICATE: {
        en: "Duplicate",
        es: "Duplicar",
        pt: "Duplicar"
    },
    RENAME_CONFIG: {
        en: "Rename Configuration",
        es: "Renombrar Configuración",
        pt: "Renombrar Configuração"
    },
    ENTER_NEW_NAME: {
        en: "Enter new name:",
        es: "Introduce el nuevo nombre:",
        pt: "Introduce el nuevo nombre:"
    },
    DUPLICATE_CONFIG: {
        en: "Duplicate Configuration",
        es: "Duplicar Configuración",
        pt: "Duplicar Configuração"
    },
    DELETE_MULTIPLE: {
        en: "Delete Multiple",
        es: "Eliminar Múltiples",
        pt: "Eliminar Múltiples"
    },
    DELETE_MULTIPLE_CONFIRM: {
        en: "Are you sure you want to delete {count} configurations?",
        es: "¿Estás seguro de que quieres eliminar {count} configuraciones?",
        pt: "¿Estás seguro de que quieres eliminar {count} configurações?"
    },
    DELETE_CONFIRM_MSG: {
        en: "Are you sure you want to delete \"{name}\"? This action cannot be undone.",
        es: "¿Estás seguro de que deseas eliminar \"{name}\"? Esta acción no se puede deshacer."
    },
    CONFIG_NAME_LABEL: {
        en: "Configuration Name",
        es: "Nombre de la Configuración",
        pt: "Nombre de la Configuração"
    },
    MY_NEW_CONFIG_PLACEHOLDER: {
        en: "My New Config",
        es: "Mi Nueva Config",
        pt: "Mi Nova Config"
    },
    SELECT_BASE: {
        en: "Select Base",
        es: "Seleccionar Base",
        pt: "Selecionar Base"
    },
    TEMPLATE_DEFAULT: {
        en: "Default",
        es: "Default",
        pt: "Default"
    },
    TEMPLATE_DEFAULT_DESC: {
        en: "CS2 Base",
        es: "Base CS2",
        pt: "Base CS2"
    },
    TEMPLATE_EMPTY: {
        en: "Empty",
        es: "Vacía",
        pt: "Vacía"
    },
    TEMPLATE_EMPTY_DESC: {
        en: "No Binds",
        es: "Sin Binds",
        pt: "Sin Binds"
    },
    TEMPLATE_RECOMMENDED: {
        en: "Recommended",
        es: "Recomendada",
        pt: "Recomendada"
    },
    TEMPLATE_COMING_SOON: {
        en: "Coming Soon",
        es: "Próximamente",
        pt: "Próximamente"
    },
    SAVE_CONFIG: {
        en: "Save Configuration",
        es: "Guardar Configuración",
        pt: "Guardar Configuração"
    },
    LOGIN_WITH_GOOGLE: {
        en: "Login with Google",
        es: "Iniciar con Google",
        pt: "Iniciar con Google"
    },
    ASSIGN_KEY: {
        en: "Assign key to load this CFG ingame",
        es: "Asignar tecla para cargar esta CFG ingame",
        pt: "Asignar tecla para cargar esta CFG ingame"
    },
    // Launch Options Page
    LAUNCH_OPTIONS_DESC: {
        en: "External Steam parameters that affect how the CS2 executable starts. Copy the generated string directly into the game properties in Steam.",
        es: "Parámetros externos de Steam que afectan cómo se inicia el ejecutable de CS2. Copia la cadena generada directamente en las propiedades del juego en Steam.",
        pt: "Parámetros externos de Steam que afectan cómo se inicia el ejecutable de CS2. Copia la cadena generada directamente en las propiedades del juego en Steam."
    },
    STEAM_LAUNCH_STRING_LABEL: {
        en: "Steam Launch String",
        es: "Cadena de Lanzamiento de Steam",
        pt: "Cadena de Inicialização de Steam"
    },
    STEAM_LAUNCH_INSTRUCTIONS: {
        en: "Copy this into Steam > Properties > General > Launch Options.",
        es: "Copia esto en Steam > Propiedades > General > Parámetros de lanzamiento.",
        pt: "Copia esto en Steam > Propiedades > General > Parámetros de lanzamiento."
    },
    MIRA_COMO_SE_HACE: {
        en: "See how it's done!",
        es: "¡Mira acá como se hace!",
        pt: "¡Mira acá como se hace!"
    },
    COMMAND_REFERENCE: {
        en: "Command Reference",
        es: "Referencia de Comandos",
        pt: "Referencia de Comandos"
    },
    LAUNCH_OPTIONS_COPY: {
        en: "Copy",
        es: "Copiar",
        pt: "Copiar"
    },
    LAUNCH_OPTIONS_COPIED: {
        en: "Copied!",
        es: "¡Copiado!",
        pt: "¡Copiado!"
    },
    LAUNCH_OPTIONS_GIF_ALT: {
        en: "How to set launch options",
        es: "Cómo configurar los parámetros de lanzamiento",
        pt: "Cómo configurar los parámetros de lanzamiento"
    },
    CMD_NOVID_DESC: {
        en: "Skip Valve's intro video",
        es: "Saltar video inicial de Valve",
        pt: "Saltar video inicial de Valve"
    },
    CMD_HIGH_DESC: {
        en: "High CPU priority",
        es: "Prioridad alta de CPU",
        pt: "Prioridad alta de CPU"
    },
    CMD_CONSOLE_DESC: {
        en: "Open console on startup",
        es: "Abrir consola al iniciar",
        pt: "Abrir consola al iniciar"
    },
    CMD_REFRESH_DESC: {
        en: "Force monitor refresh rate",
        es: "Forzar Hz del monitor",
        pt: "Forzar Hz del monitor"
    },
    CMD_FULLSCREEN_DESC: {
        en: "Fullscreen mode",
        es: "Modo pantalla completa",
        pt: "Modo pantalla completa"
    },
    CMD_RESO_DESC: {
        en: "Force resolution width and height",
        es: "Forzar ancho y alto de resolución",
        pt: "Forzar ancho y alto de resolução"
    },
    // Advanced Page
    ADVANCED_DESC: {
        en: "Advanced technical settings to optimize network latency, audio protocols, and low-level system adjustments.",
        es: "Configuraciones técnicas avanzadas para optimizar la latencia de red, protocolos de audio y ajustes del sistema de bajo nivel.",
        pt: "Configurações técnicas avanzadas para optimizar la latencia de red, protocolos de audio y ajustes del sistema de bajo nivel."
    },
    NETWORK_PROTOCOLS: {
        en: "Network Protocols",
        es: "Protocolos de Red",
        pt: "Protocolos de Red"
    },
    SYSTEM_INTERFACE: {
        en: "System Interface",
        es: "Interfaz del Sistema",
        pt: "Interfaz del Sistema"
    },
    AUDIO_ENGINE: {
        en: "Audio Engine",
        es: "Motor de Audio",
        pt: "Motor de Audio"
    },
    TRAFFIC_RATE_DESC: {
        en: "Maximum bandwidth (rate)",
        es: "Ancho de banda máximo (rate)",
        pt: "Ancho de banda máximo (rate)"
    },
    PACKET_BUFFERING_DESC: {
        en: "Network smoothing",
        es: "Suavizado de red",
        pt: "Suavizado de red"
    },
    DEVELOPER_CONSOLE_DESC: {
        en: "Console with [~]",
        es: "Consola con [~]",
        pt: "Consola con [~]"
    },
    HUD_TELEMETRY_DESC: {
        en: "Ping and FPS on screen",
        es: "Ping y FPS en pantalla",
        pt: "Ping y FPS en pantalla"
    },
    STREAMER_MODE_DESC: {
        en: "Anonymize names",
        es: "Anonimizar nombres",
        pt: "Anonimizar nombres"
    },
    MASTER_VOLUME_DESC: {
        en: "General sound level",
        es: "Nivel de sonido general",
        pt: "Nivel de sonido general"
    },
    BUFFER_LATENCY_DESC: {
        en: "Low latency sound",
        es: "Sonido de baja latencia",
        pt: "Sonido de baja latencia"
    },
    MIC_THRESHOLD_DESC: {
        en: "Microphone detection threshold",
        es: "Umbral de detección del micrófono",
        pt: "Umbral de detecção del micrófono"
    },
    TRAFFIC_RATE_LABEL: {
        en: "Traffic Rate",
        es: "Límite de Tráfico",
        pt: "Límite de Tráfico"
    },
    PACKET_BUFFERING_LABEL: {
        en: "Packet Buffering",
        es: "Suavizado de Paquetes",
        pt: "Suavizado de Paquetes"
    },
    DEVELOPER_CONSOLE_LABEL: {
        en: "Developer Console",
        es: "Consola de Desarrollador",
        pt: "Consola de Desarrollador"
    },
    HUD_TELEMETRY_LABEL: {
        en: "HUD Telemetry",
        es: "Telemetría del HUD",
        pt: "Telemetría del HUD"
    },
    STREAMER_MODE_LABEL: {
        en: "Streamer Mode",
        es: "Modo Streamer",
        pt: "Modo Streamer"
    },
    MASTER_VOLUME_LABEL: {
        en: "Master Volume",
        es: "Volumen Maestro",
        pt: "Volumen Maestro"
    },
    BUFFER_LATENCY_LABEL: {
        en: "Buffer Latency",
        es: "Latencia del Buffer",
        pt: "Latencia del Buffer"
    },
    MIC_THRESHOLD_LABEL: {
        en: "Mic Threshold",
        es: "Umbral del Micrófono",
        pt: "Umbral del Micrófono"
    },
    GRAFICOS_Y_PERFORMANCE: {
        en: "Graphics & Performance",
        es: "Gráficos y Performance",
        pt: "Gráficos y Performance"
    },
    // Video Parameters Page
    VIDEO_DESC_HELP: {
        en: "Configuration of visual and performance parameters for CS2. Optimize resolution and FPS for the best competitive experience.",
        es: "Configuración de parámetros visuales y de rendimiento de CS2. Optimiza la resolución y FPS para obtener la mejor experiencia competitiva.",
        pt: "Configuração de parámetros visuales y de rendimiento de CS2. Optimiza la resolução y FPS para obtener la mejor experiencia competitiva."
    },
    DISPLAY_RESOLUTION_TITLE: {
        en: "Display & Resolution",
        es: "Pantalla y Resolución",
        pt: "Pantalla y Resolução"
    },
    RESOLUTION_LABEL: {
        en: "Resolution",
        es: "Resolución",
        pt: "Resolução"
    },
    RESOLUTION_DESC_HELP: {
        en: "Monitor's native or custom resolution.",
        es: "Resolución nativa o personalizada del monitor.",
        pt: "Resolução nativa o personalizada del monitor."
    },
    DISPLAY_MODE_LABEL: {
        en: "Display Mode",
        es: "Modo de Pantalla",
        pt: "Modo de Pantalla"
    },
    REFRESH_RATE_LABEL: {
        en: "Refresh Rate",
        es: "Tasa de Refresco",
        pt: "Tasa de Refresco"
    },
    MAX_INGAME_FPS_LABEL: {
        en: "Max In-Game FPS",
        es: "FPS máximos en juego",
        pt: "FPS máximos en juego"
    },
    MAX_MENU_FPS_LABEL: {
        en: "Max Menu FPS",
        es: "FPS máximos en menú",
        pt: "FPS máximos en menú"
    },
    BOOST_CONTRAST_LABEL: {
        en: "Boost Player Contrast",
        es: "Aumentar contraste de jugadores",
        pt: "Aumentar contraste de jugadores"
    },
    SHADOW_QUALITY_LABEL: {
        en: "Global Shadow Quality",
        es: "Calidad de sombras global",
        pt: "Calidad de sombras global"
    },
    TEXTURE_DETAIL_LABEL: {
        en: "Model / Texture Detail",
        es: "Detalle de modelos y texturas",
        pt: "Detalle de modelos y texturas"
    },
    TEXTURE_FILTERING_LABEL: {
        en: "Texture Filtering Mode",
        es: "Modo de filtrado de texturas",
        pt: "Modo de filtrado de texturas"
    },
    ANTI_ALIASING_LABEL: {
        en: "Multi-Sampling Anti-Aliasing",
        es: "Suavizado de bordes (Anti-Aliasing)",
        pt: "Suavizado de bordes (Anti-Aliasing)"
    },
    NVIDIA_REFLEX_LABEL: {
        en: "NVIDIA Reflex Low Latency",
        es: "NVIDIA Reflex de baja latencia",
        pt: "NVIDIA Reflex de baja latencia"
    },
    FPS_MAX_DESC_HELP: {
        en: "No limit for maximum fluidity.",
        es: "Sin límite para máxima fluidez.",
        pt: "Sin límite para máxima fluidez."
    },
    FPS_MAX_MENU_DESC_HELP: {
        en: "Limit in menus to save energy.",
        es: "Límite en menús para ahorrar energía.",
        pt: "Límite en menús para ahorrar energía."
    },
    BOOST_CONTRAST_DESC_HELP: {
        en: "Improves visibility of character models.",
        es: "Mejora la visibilidad de los modelos de personajes.",
        pt: "Mejora la visibilidad de los modelos de personajes."
    },
    SHADOW_QUALITY_DESC_HELP: {
        en: "Allows seeing shadows from a distance.",
        es: "Permite ver sombras a distancia.",
        pt: "Permite ver sombras a distancia."
    },
    TEXTURE_DETAIL_DESC_HELP: {
        en: "Detail of models and textures.",
        es: "Detalle de modelos y texturas.",
        pt: "Detalle de modelos y texturas."
    },
    TEXTURE_FILTERING_DESC_HELP: {
        en: "Sharpness of distant textures.",
        es: "Nitidez en texturas lejanas.",
        pt: "Nitidez en texturas lejanas."
    },
    ANTI_ALIASING_DESC_HELP: {
        en: "MSAA edge smoothing.",
        es: "Suavizado de bordes MSAA.",
        pt: "Suavizado de bordes MSAA."
    },
    NVIDIA_REFLEX_DESC_HELP: {
        en: "Minimizes system latency.",
        es: "Minimiza la latencia del sistema.",
        pt: "Minimiza la latencia del sistema."
    },
    SELECT_CONFIG: {
        en: "Select Config",
        es: "Seleccionar Config",
        pt: "Selecionar Config"
    },
    DOWNLOAD: {
        en: "Download",
        es: "Descargar",
        pt: "Baixar"
    },
    RESTORE_DEFAULTS: {
        en: "Restore Defaults",
        es: "Restaurar por Defecto",
        pt: "Restaurar por Defecto"
    },
    ESSENTIALS: {
        en: "Essentials",
        es: "Esenciales",
        pt: "Esenciales"
    },
    TRAINING: {
        en: "Training",
        es: "Entrenamiento",
        pt: "Entrenamiento"
    },
    PRACTICE_BIND: {
        en: "Practice Bind",
        es: "Bind de Práctica",
        pt: "Bind de Práctica"
    },
    FPS_MAX: {
        en: "Max FPS",
        es: "FPS Máximo",
        pt: "FPS Máximo"
    },
    WELCOME_TITLE: {
        en: "Welcome to Config Strike",
        es: "Bienvenido a Config Strike",
        pt: "Bienvenido a Config Strike"
    },
    WELCOME_SUBTITLE: {
        en: "Create your first configuration to start customizing.",
        es: "Crea tu primera configuración para empezar a personalizar.",
        pt: "Crea tu primera configuração para empezar a personalizar."
    },
    ATTENTION: {
        en: "Attention",
        es: "Atención",
        pt: "Atenção"
    },
    INVALID_SHARE_CODE: {
        en: "The crosshair code is invalid.",
        es: "El código de la mira es inválido.",
        pt: "El código de la mira es inválido."
    },
    GALLERY: {
        en: "Gallery",
        es: "Galería",
        pt: "Galería"
    },
    SAVED: {
        en: "Saved",
        es: "Guardadas",
        pt: "Guardadas"
    },
    IMPORT: {
        en: "Import",
        es: "Importar",
        pt: "Importar"
    },
    EXPORT: {
        en: "Export",
        es: "Exportar",
        pt: "Exportar"
    },
    KEY_RADIAL_RADIO: {
        en: "Chat Wheel 1",
        es: "Rueda de Chat 1",
        pt: "Roda de Chat 1"
    },
    KEY_RADIAL_RADIO2: {
        en: "Chat Wheel 2",
        es: "Rueda de Chat 2",
        pt: "Roda de Chat 2"
    },
    KEY_RADIAL_RADIO3: {
        en: "Chat Wheel 3",
        es: "Rueda de Chat 3",
        pt: "Roda de Chat 3"
    },

    // Radio Module
    RADIO_COMMUNICATION_TITLE: {
        en: "Radio",
        es: "Radio",
        pt: "Rádio"
    },
    RADIO_CHAT_MENUS: {
        en: "Radio & Chat Menus",
        es: "Menús de Radio y Chat",
        pt: "Menus de Rádio e Chat"
    },
    RADIO_MENU_1: {
        en: "Radio Menu 1",
        es: "Menú de Radio 1",
        pt: "Menu de Rádio 1"
    },
    RADIO_MENU_2: {
        en: "Radio Menu 2",
        es: "Menú de Radio 2",
        pt: "Menu de Rádio 2"
    },
    RADIO_MENU_3: {
        en: "Radio Menu 3",
        es: "Menú de Radio 3",
        pt: "Menu de Rádio 3"
    },
    WHEEL_MENU: {
        en: "Wheel Menu",
        es: "Menú Radial",
        pt: "Menu Radial"
    },
    RADIO_DESC_1: {
        en: "Go, Fall Back, Hold",
        es: "Ir, Retroceder, Mantener",
        pt: "Ir, Recuar, Manter"
    },
    RADIO_DESC_2: {
        en: "Roger, Negative, Thanks",
        es: "Recibido, Negativo, Gracias",
        pt: "Copiado, Negativo, Obrigado"
    },
    RADIO_DESC_3: {
        en: "Enemy Spotted, Backup",
        es: "Enemigo visto, Ayuda",
        pt: "Inimigo avistado, Ajuda"
    },
    SELECT_SLOT_COMMAND: {
        en: "Select Command for Slot",
        es: "Selecciona comando para ranura",
        pt: "Selecione comando para slot"
    },
    SELECT_A_SLOT: {
        en: "Select a Slot",
        es: "Selecciona una ranura",
        pt: "Selecione um slot"
    },
    WHEELS_ACTIVE: {
        en: "Wheels Active",
        es: "Ruedas Activas",
        pt: "Rodas Ativas"
    },

    // Request & Movement
    RADIO_CAT_PREP: { en: "Preparation & Movement", es: "Preparación y Movimiento", pt: "Preparação e Movimento" },
    RADIO_CMD_GOGOGO: { en: "Go Go Go!", es: "¡Vamos, vamos, vamos!", pt: "Vamos, vamos, vamos!" },
    RADIO_CMD_ONMYWAY: { en: "On my way", es: "Voy de camino", pt: "Estou a caminho" },
    RADIO_CMD_FOLLOWME: { en: "Follow me", es: "Seguidme", pt: "Sigam-me" },
    RADIO_CMD_COVERME: { en: "Cover me", es: "Cubridme", pt: "Cubram-me" },
    RADIO_CMD_REGROUP: { en: "Regroup", es: "Reagrupaos", pt: "Reagrupar" },
    RADIO_CMD_STICKTOGETHER: { en: "Stick together", es: "Mantengámonos juntos", pt: "Fiquem juntos" },
    RADIO_CMD_HOLDPOS: { en: "Hold Position", es: "Mantened la posición", pt: "Manter posição" },
    RADIO_CMD_FALLBACK: { en: "Fall Back!", es: "¡Retroceded!", pt: "Recuar!" },
    RADIO_CMD_SPREADOUT: { en: "Spread Out", es: "Desplegaos", pt: "Espalhem-se" },
    RADIO_CMD_SPLIT: { en: "Split Up", es: "Dividíos", pt: "Dividam-se" },
    RADIO_CMD_FLANK: { en: "Flank", es: "Flanquead", pt: "Flanquear" },

    // Reports & Info
    RADIO_CAT_REPORT: { en: "Reports & Info", es: "Reportes e Información", pt: "Relatórios e Info" },
    RADIO_CMD_SECTORCLEAR: { en: "Sector Clear", es: "Sector despejado", pt: "Setor limpo" },
    RADIO_CMD_PEEKING: { en: "I'm Peeking", es: "Voy a asomarme", pt: "Vou espreitar" },
    RADIO_CMD_HEARDNOISE: { en: "Heard Noise", es: "He oído algo", pt: "Ouvi barulho" },
    RADIO_CMD_ENEMYSPOTTED: { en: "Enemy Spotted", es: "Enemigos avistados", pt: "Inimigos avistados" },
    RADIO_CMD_SNIPER: { en: "Sniper Spotted", es: "Francotirador avistado", pt: "Sniper avistado" },
    RADIO_CMD_BOMBCARRIER: { en: "Bomb Carrier Here", es: "El portador de la bomba está aquí", pt: "Portador da bomba aqui" },
    RADIO_CMD_INPOSITION: { en: "In Position", es: "En posición", pt: "Em posição" },
    RADIO_CMD_MULTIPLEENEMIES: { en: "Multiple Enemies", es: "Múltiples enemigos", pt: "Múltiplos inimigos" },
    RADIO_CMD_ONEENEMY: { en: "One Enemy", es: "Un enemigo aquí", pt: "Um inimigo aqui" },
    RADIO_CMD_BOMBATA: { en: "Bomb is at A", es: "La bomba está en A", pt: "Bomba no A" },
    RADIO_CMD_BOMBATB: { en: "Bomb is at B", es: "La bomba está en B", pt: "Bomba no B" },

    // Requests & Grenades
    RADIO_CAT_REQUEST: { en: "Requests & Grenades", es: "Solicitudes y Granadas", pt: "Pedidos e Granadas" },
    RADIO_CMD_NEEDBACKUP: { en: "Need Backup", es: "Necesito refuerzos", pt: "Preciso de reforços" },
    RADIO_CMD_NEEDSMOKE: { en: "Need Smoke", es: "Necesito humo", pt: "Preciso de smoke" },
    RADIO_CMD_NEEDFLASH: { en: "Need Flash", es: "Necesito una cegadora", pt: "Preciso de flash" },
    RADIO_CMD_NEEDFIRE: { en: "Need Molotov", es: "Necesito un molotov", pt: "Preciso de molotov" },
    RADIO_CMD_NEEDDECOY: { en: "Need Decoy", es: "Necesito un señuelo", pt: "Preciso de decoy" },
    RADIO_CMD_NEEDHE: { en: "Need HE", es: "Necesito una granada HE", pt: "Preciso de HE" },
    RADIO_CMD_NEEDPLAN: { en: "What's the plan?", es: "¿Cuál es el plan?", pt: "Qual é o plano?" },

    // Economy
    RADIO_CAT_ECO: { en: "Economy", es: "Economía", pt: "Economia" },
    RADIO_CMD_NEEDWEAPON: { en: "Need Weapon", es: "Necesito un arma", pt: "Preciso de arma" },
    RADIO_CMD_REQUESTDROP: { en: "Can I get a drop?", es: "¿Me podéis dar un arma?", pt: "Podem me dropar?" },
    RADIO_CMD_FULLBUY: { en: "Full Buy", es: "Comprad (Full Buy)", pt: "Comprar tudo (Full Buy)" },
    RADIO_CMD_ECO: { en: "Eco Round", es: "Eco (No gastéis)", pt: "Eco (Não gastem)" },
    RADIO_CMD_OFFERDROP: { en: "I can drop", es: "Ofrecer Drop (Tengo extra)", pt: "Posso dropar" },
    RADIO_CMD_DONATE: { en: "Donate Weapon", es: "Dar arma", pt: "Dropar arma" },

    // Map Planning
    RADIO_CAT_PLAN: { en: "Map Planning", es: "Planificación de Mapa", pt: "Planejamento de Mapa" },
    RADIO_CMD_PINGA: { en: "Ping Site A", es: "Ping sitio A", pt: "Ping Site A" },
    RADIO_CMD_PINGB: { en: "Ping Site B", es: "Ping sitio B", pt: "Ping Site B" },
    RADIO_CMD_PINGMID: { en: "Ping Mid", es: "Ping Medio", pt: "Ping Meio" },
    RADIO_CMD_ROTATETOME: { en: "Rotate to Me", es: "Rotad hacia mí", pt: "Rotacionem para mim" },

    // Social
    RADIO_CAT_SOCIAL: { en: "Responses & Social", es: "Respuestas y Social", pt: "Respostas e Social" },
    RADIO_CMD_AFFIRMATIVE: { en: "Affirmative", es: "Afirmativo", pt: "Afirmativo" },
    RADIO_CMD_NEGATIVE: { en: "Negative", es: "Negativo", pt: "Negativo" },
    RADIO_CMD_THANKS: { en: "Thanks", es: "Gracias", pt: "Obrigado" },
    RADIO_CMD_CHEER: { en: "Cheer", es: "¡Vamos!", pt: "Vamos!" },
    RADIO_CMD_COMPLIMENT: { en: "Compliment", es: "Elogiar / Buen trabajo", pt: "Elogiar / Bom trabalho" },
    RADIO_CMD_SORRY: { en: "Sorry", es: "Perdón", pt: "Desculpe" },
    RADIO_CMD_PEP: { en: "Nice Job", es: "Ánimo equipo", pt: "Bom trabalho equipe" },
    RADIO_CMD_QUIET_RELAX: { en: "Relax", es: "Calmaos / Relax", pt: "Relaxem" },
    RADIO_CMD_SILENCE: { en: "Silence", es: "Silencio", pt: "Silêncio" },
    RADIO_CMD_YES: { en: "Yes", es: "Sí", pt: "Sim" },
    RADIO_CMD_NO: { en: "No", es: "No", pt: "Não" },

    UNBOUND: {
        en: "Unbound",
        es: "Sin asignar",
        pt: "Não atribuído"
    },
    COPY_TO_CONSOLE_DESC: {
        en: "Copy commands to clipboard to paste in console",
        es: "Copiar comandos al portapapeles para pegar en consola",
        pt: "Copiar comandos para a área de transferência para colar no console"
    },
    COPY_TO_CONSOLE_DESC_QUICK: {
        en: "Copy Cmds",
        es: "Copiar Cmds",
        pt: "Copiar Cmds"
    },
    CMD_COPY_SUCCESS: {
        en: "Commands copied!",
        es: "¡Comandos copiados!",
        pt: "Comandos copiados!"
    },
    // Manager View
    BATCH_LOCK: {
        en: "Lock",
        es: "Bloquear",
        pt: "Bloquear"
    },
    BATCH_UNLOCK: {
        en: "Unlock",
        es: "Desbloquear",
        pt: "Desbloquear"
    },
    BATCH_DELETE: {
        en: "Delete",
        es: "Eliminar",
        pt: "Eliminar"
    },
    DUPLICATE_ACTION: {
        en: "Duplicate",
        es: "Duplicar",
        pt: "Duplicar"
    },
    UNLOCK_ACTION: {
        en: "Unlock",
        es: "Desbloquear",
        pt: "Desbloquear"
    },
    LOCK_ACTION: {
        en: "Set Read-Only",
        es: "Hacer Solo Lectura",
        pt: "Tornar Somente Leitura"
    },
    DELETE_ACTION: {
        en: "Delete",
        es: "Eliminar",
        pt: "Eliminar"
    },
    CONFIRM_BATCH_DELETE: {
        en: "Are you sure you want to delete {count} configs?",
        es: "¿Estás seguro de que quieres eliminar {count} configuraciones?",
        pt: "Tem certeza de que deseja excluir {count} configurações?"
    },
    TABLE_STATUS: {
        en: "Status",
        es: "Estado",
        pt: "Estado"
    },
    TABLE_BIND: {
        en: "Bind",
        es: "Tecla",
        pt: "Tecla"
    },
    TABLE_UPDATED: {
        en: "Updated",
        es: "Actualizado",
        pt: "Atualizado"
    },
    SELECTED_FROM_TOTAL: {
        en: "{count} Selected",
        es: "{count} Seleccionadas",
        pt: "{count} Selecionadas"
    },
    // Binds Module Actions
    RESTORING_DEFAULTS: {
        en: "Restoring Defaults",
        es: "Restaurando por defecto",
        pt: "Restaurando padrões"
    },
    RESTORING_DEFAULTS_CONFIRM: {
        en: "Are you sure you want to restore default settings? This will overwrite your current settings.",
        es: "¿Estás seguro de que quieres restaurar los valores por defecto? Esto sobrescribirá tus ajustes actuales.",
        pt: "Tem certeza de que deseja restaurar as configurações padrão? Isso substituirá seus ajustes atuais."
    },
    RESTORE: {
        en: "Restore",
        es: "Restaurar",
        pt: "Restaurar"
    },
    CLEAR_ALL_BINDS: {
        en: "Clear All Binds",
        es: "Eliminar todos los binds",
        pt: "Limpar todos os binds"
    },
    CLEAR_ALL_BINDS_CONFIRM: {
        en: "Are you sure you want to clear all binds? This action cannot be undone.",
        es: "¿Estás seguro de que quieres eliminar todos los binds? Esta acción no se puede deshacer.",
        pt: "Tem certeza de que deseja limpar todos os binds? Esta ação não pode ser desfeita."
    },
    CLEAR_ALL: {
        en: "Clear All",
        es: "Eliminar Todo",
        pt: "Limpar Tudo"
    },
    RESTORE_DEFAULTS: {
        en: "Restore Defaults",
        es: "Restaurar por defecto",
        pt: "Restaurar Padrões"
    },
    CLEAR: {
        en: "Clear",
        es: "Limpiar",
        pt: "Limpar"
    },
    // BUY/ACTIVAR page (BlogView)
    BUY_TITLE: {
        en: "<span>Thank you</span> for supporting the project",
        es: "<span>Gracias</span> por apoyar el proyecto",
        pt: "<span>Obrigado</span> por apoiar o projeto"
    },
    BUY_SUBTITLE: {
        en: "Making this app was always a dream that finally came true. I built it with a lot of love and dedication, and your support means everything to keep it growing. Seriously, thank you.",
        es: "Hacer esta app siempre fue un sueño que finalmente se cumplió. La construí con mucho cariño y dedicación, y tu apoyo me viene muy bien para poder seguir mejorándola. De verdad, gracias.",
        pt: "Fazer este app sempre foi um sonho que finalmente se realizou. Eu o construí com muito carinho e dedicação, e seu apoio significa muito para continuar melhorando. Sério, obrigado."
    },
    BUY_ACTIVATE_CARD_TITLE: {
        en: "Activate PRO license",
        es: "Activar licencia PRO",
        pt: "Ativar licença PRO"
    },
    BUY_KEY_BTN: {
        en: "Activate",
        es: "Activar",
        pt: "Ativar"
    },
    BUY_KEY_VALIDATING: {
        en: "Validating...",
        es: "Validando...",
        pt: "Validando..."
    },
    BUY_KEY_SUCCESS: {
        en: "License activated! All PRO features are now available.",
        es: "¡Licencia activada! Todas las funciones PRO ya están disponibles.",
        pt: "Licença ativada! Todos os recursos PRO já estão disponíveis."
    },
    BUY_KEY_ALREADY_PRO: {
        en: "Your PRO license is already active. Enjoy all the features!",
        es: "Tu licencia PRO ya está activa. ¡Disfrutá todas las funciones!",
        pt: "Sua licença PRO já está ativa. Aproveite todos os recursos!"
    },
    BUY_KEY_HINT: {
        en: "Paste the key exactly as you received it, dashes included.",
        es: "Pegá la key tal cual la recibiste, con los guiones incluidos.",
        pt: "Cole a key exatamente como a recebeu, com os hífens incluídos."
    },
    // Motivos por los que un canje no procede. El server manda el código
    // (`reason`) y acá se traduce; ver app/api/keys/redeem/route.js.
    BUY_KEY_ERR_NOT_FOUND: {
        en: "That key doesn't exist. Check that you copied it correctly.",
        es: "Esa clave no existe. Revisá que esté bien copiada.",
        pt: "Essa chave não existe. Verifique se copiou corretamente."
    },
    BUY_KEY_ERR_REVOKED: {
        en: "That key was cancelled.",
        es: "Esa clave fue dada de baja.",
        pt: "Essa chave foi cancelada."
    },
    BUY_KEY_ERR_EXHAUSTED: {
        en: "That key has already been used the maximum number of times.",
        es: "Esa clave ya se usó el máximo de veces.",
        pt: "Essa chave já foi usada o número máximo de vezes."
    },
    BUY_KEY_ERR_ALREADY_REDEEMED: {
        en: "You already redeemed this key — the access is on your account.",
        es: "Ya canjeaste esta clave — el acceso está en tu cuenta.",
        pt: "Você já resgatou esta chave — o acesso está na sua conta."
    },
    // No se gastó la clave a propósito: el acceso es uno por cuenta, así que
    // le sirve para regalar o para otra cuenta suya.
    BUY_KEY_ERR_ALREADY_PRO: {
        en: "You already have PRO on this account, so we didn't use up the key. Keep it to gift it or to use on another account.",
        es: "Ya tenés PRO en esta cuenta, así que no gastamos la clave. Guardala para regalar o para usar en otra cuenta.",
        pt: "Você já tem PRO nesta conta, então não gastamos a chave. Guarde-a para presentear ou usar em outra conta."
    },
    BUY_KEY_WHERE_TITLE: {
        en: "Don't have your key yet?",
        es: "¿Aún no tenés tu key?",
        pt: "Ainda não tem sua key?"
    },
    BUY_KEY_WHERE_DESC: {
        en: "You can get a license key by supporting the project on Patreon. Every contribution helps keep Config Strike alive and growing.",
        es: "Podés obtener una key apoyando el proyecto en Patreon. Cada aporte ayuda a que Config Strike siga vivo y creciendo.",
        pt: "Você pode obter uma key apoiando o projeto no Patreon. Cada contribuição ajuda a manter o Config Strike vivo e crescendo."
    },
    BUY_ACTION_TITLE: {
        en: "Get PRO",
        es: "Obtén PRO",
        pt: "Obter PRO"
    },
    BUY_ACTION_DESC: {
        en: "Choose your preferred platform today to get instant access to all locked features.",
        es: "Elige tu plataforma preferida hoy mismo para obtener acceso instantáneo a todas las características bloqueadas.",
        pt: "Escolha a sua plataforma preferida hoje para obter acesso instantâneo a todos os recursos bloqueados."
    },
    BUY_BTN_PATREON: {
        en: "Support on Patreon",
        es: "Apoyar en Patreon",
        pt: "Apoiar no Patreon"
    },
    SUPPORT_BANNER_TITLE: {
        en: "THANKS FOR THE SUPPORT",
        es: "GRACIAS POR EL APOYO",
        pt: "OBRIGADO PELO APOIO"
    },
    SUPPORT_BANNER_DESC: {
        en: "Sorry for locking some sections — I'd love to keep everything free, but I need a way to sustain this.",
        es: "Perdón si bloqueo algunas secciones para recaudar, me encantaría dejarla libre para todos pero necesito un respaldo.",
        pt: "Desculpe bloquear algumas seções — adoraria deixar tudo livre, mas preciso de um suporte para continuar."
    },
    PATREON_BANNER_TITLE: {
        en: "JOIN THE PATREON",
        es: "UNITE AL PATREON",
        pt: "ENTRE NO PATREON"
    },
    PATREON_BANNER_DESC: {
        en: "You can be part of it, access upcoming versions or projects, reach out, or just support. If you like the project, backing it is the best way to ensure its future.",
        es: "Podés formar parte, acceder a próximas versiones o proyectos, contactarme o solo apoyar. Si te gusta el proyecto, apoyarlo es la mejor forma de asegurar su continuidad y mejoras futuras.",
        pt: "Você pode fazer parte, acessar versões futuras ou projetos, entrar em contato ou apenas apoiar. Se gosta do projeto, apoiá-lo é a melhor forma de garantir sua continuidade."
    },
    SIDEBAR_LOGIN: {
        en: "LOG IN",
        es: "INGRESAR",
        pt: "ENTRAR"
    },
    SIDEBAR_LOGIN_REQUIRED: {
        en: "Log in with Steam to use ConfigStrike",
        es: "Iniciá sesión con Steam para usar ConfigStrike",
        pt: "Faça login com Steam para usar o ConfigStrike"
    },
    LOGIN_TITLE: {
        en: "Log in with your Steam account",
        es: "Entrá con tu cuenta de Steam",
        pt: "Entre com sua conta Steam"
    },
    LOGIN_SUBTITLE: {
        en: "ConfigStrike needs your Steam account to save and sync your configs.",
        es: "ConfigStrike necesita tu cuenta de Steam para guardar y sincronizar tus configs.",
        pt: "O ConfigStrike precisa da sua conta Steam para salvar e sincronizar suas configs."
    },
    LOGIN_TERMS: {
        en: "I accept the ConfigStrike terms and conditions of use.",
        es: "Acepto los términos y condiciones de uso de ConfigStrike.",
        pt: "Aceito os termos e condições de uso do ConfigStrike."
    },
    LOGIN_STEAM_BUTTON: {
        en: "Log in with Steam",
        es: "Iniciar sesión con Steam",
        pt: "Entrar com Steam"
    },
    LOGIN_HINT: {
        en: "We only use your public SteamID to identify your account.",
        es: "Solo usamos tu SteamID público para identificar tu cuenta.",
        pt: "Usamos apenas seu SteamID público para identificar sua conta."
    },
    LOGIN_ERROR_TERMS: {
        en: "You have to accept the terms and conditions to continue.",
        es: "Tenés que aceptar los términos y condiciones para continuar.",
        pt: "Você precisa aceitar os termos e condições para continuar."
    },
    LOGIN_ERROR_GENERIC: {
        en: "Could not log in. Please try again.",
        es: "No se pudo iniciar sesión. Probá de nuevo.",
        pt: "Não foi possível entrar. Tente novamente."
    },
    ACCOUNT_TITLE: {
        en: "ACCOUNT",
        es: "CUENTA",
        pt: "CONTA"
    },
    ACCOUNT_STEAMID: {
        en: "SteamID",
        es: "SteamID",
        pt: "SteamID"
    },
    ACCOUNT_MEMBER_SINCE: {
        en: "Member since",
        es: "Miembro desde",
        pt: "Membro desde"
    },
    ACCOUNT_SYNC: {
        en: "Sync",
        es: "Sincronización",
        pt: "Sincronização"
    },
    ACCOUNT_SYNC_NEVER: {
        en: "no sync yet",
        es: "todavía sin sincronizar",
        pt: "ainda sem sincronizar"
    },
    ACCOUNT_SYNC_NOW: {
        en: "Sync now",
        es: "Sincronizar ahora",
        pt: "Sincronizar agora"
    },
    ACCOUNT_STEAM_PROFILE: {
        en: "View Steam profile",
        es: "Ver perfil de Steam",
        pt: "Ver perfil da Steam"
    },
    ACCOUNT_LOGOUT: {
        en: "Log out",
        es: "Cerrar sesión",
        pt: "Sair"
    }
}
